import occoApi from './occoAPI-module.js';
import * as shareBucketApi from '../../../packages/src/api/shareInBucket.js';
import {
  DEFAULT_PRINTING_CONFIRMATION_TEXT,
  DEFAULT_PIC_SIZE,
  DEFAULT_EMAIL_ENDS,
  DEFAULT_EVENT_SUPPORT_LINK,
  DEFAULT_EVENT_MULTIPLIER,
  DEFAULT_LOGO,
  blockOverlay,
  DEFAULT_WATERMARK,
  DEFAULT_SLIDESHOW_BG,
  DEFAULT_LOGO_LINK,
  DEFAULT_COPIES,
  DEFAULT_PRINT,
  DEFAULT_FROM_ADDRESS,
  DEFAULT_NAME,
  DEFAULT_EMAILSUBJECT,
  EMAIL_TEMP,
  EMAIL_SHARING_TEMP,
  RECEIPT_EMAIL_BODY_TEMP,
  SHARING_BODY_TEMPLATE_HTML,
  SHARING_VIDEO_BODY_TEMPLATE_HTML,
  SHARING_360_BODY_TEMPLATE_HTML,
  SMS_TEMP,
  PRIVACY_POLICY_LINK,
  MIN_PHOTO_AUTO_DELETE_DAYS,
  MAX_PHOTO_AUTO_DELETE_DAYS,
  MAX_PHOTO_STREAM_AVAILABLE_MINUTES,
  MAX_PRINT_COUNT,
  uploadImage,
  fillTimeZoneList,
  normaliseUrl,
  setUnlockCodes,
  elId,
  activateMultiTagsInput,
  hideLoading,
  showLoading,
  is_Admin,
  is_Super,
  setLoaderToCont,
  fromUrlFilename,
  addNewUnlockCode,
  refreshPage,
  isURL,
  htmlTagRemoval,
  isTemplate,
  isTemplateShare,
  isReceiptEmailBody,
  getUnlockCodeList,
  uploadFileToS3,
  isTemplateSMS,
  activateMultiRegiredTagsToCreateStoryInput,
  resetAndEmptyInputs,
  setValueIfNotEmpty,
  getTrackerSnippetForEvent,
} from './common-utils-module.js';
import { safeJSONParse } from './utils/serialize.js';
import LANG from '../lang/prop-en-module.js';
import { vipToken, storiesPrintPool } from './data.js';
import { makeInputTags } from './data-constr.js';
import * as customPopUp from './views/modals/customPopUp.js';
import { alertMessagePopup } from './views/modals/others.js';
import { defaultTo } from './base.js';
import getQueryProvider from './getQueryProvider-module.js';
import { selectedEventId } from './utils/eventData.js';
import { editEventActivatePrinter } from './views/editOrAddEventForm.js';
import {
  initWebappControls,
  setDefaultLogoSrc,
  setDefaultBackgroundSrc,
  setDefaultBannerTopSrc,
  setDefaultBannerBottomSrc,
  isValidSMSText,
  enableSMSForm,
} from './eventSettings/webappSettings.js';
import { initNotificationSettings, getNotificationData } from './eventSettings/notificationSettings/index.js';
import organisationData from './organisation/index.js';
import {
  createStockImageRow,
  getThumbHTML,
  resetStockImagesList,
  stockTabCollectAndValidateDataAddOrEditEvent,
  updateStockImageInfo,
} from './eventManager/stockImage.ts';
import {
  applyEventLanguageSettingsToForm,
  collectEventLanguageSettingsFromForm,
  initEventLanguageSettingsForm,
} from './eventManager/eventLanguageSettings.js';
import { initEventOrganisationDataStorage } from '../../../packages/src/eventOrganisationDataStorage.js';
import { getEventLanguageSettings } from '../../../packages/src/localization/languageSettings.js';

const eventOrganisationDataStorage = initEventOrganisationDataStorage();
getQueryProvider.init();
const { ALBUM_TYPES, KEY_TYPE, KEY_VALUE, EVENT_OWNER_API_KEY, EVENT_PRIVATE_API_KEY } = getQueryProvider;

function initDeleteBtn() {
  const deleteSelectedButton = document.getElementById('deleteSelectedButton');
  return {
    disable(disabled) {
      if (deleteSelectedButton) {
        deleteSelectedButton.disabled = disabled;
      }
    },
  };
}

const deleteBtn = initDeleteBtn();

function initEditEventButton() {
  const editEventButton = elId('editEventAction');

  return {
    enable() {
      editEventButton.disabled = false;
    },
    disable() {
      editEventButton.disabled = true;
    },
  };
}

const editEventButtonControl = initEditEventButton();

function initManageEventOpts() {
  const valueName = 'value';
  const data = {};

  return {
    addItem,
    setValues,
    resetToDefaultValues,
    preparedForApi,
  };

  function addItem({ itemType, apiName, interpretation = [], defaultValue = '' }) {
    data[apiName] = { apiName, defaultValue, itemType, interpretation };
  }

  function prepareToSetValue(item, value) {
    const { defaultValue, interpretation } = item;
    const rawValue = defaultTo(defaultValue, value);
    return findInterpretationValue(interpretation, rawValue);

    function findInterpretationValue() {
      for (const [valueToSet, valueForApi] of interpretation) {
        if (valueForApi === rawValue) {
          return valueToSet;
        }
      }
      return rawValue;
    }
  }

  function prepareApiValue(item, value) {
    const { defaultValue, interpretation } = item;
    const rawValue = defaultTo(defaultValue, value);
    return findInterpretationValue(interpretation, rawValue);

    function findInterpretationValue() {
      for (const [valueToSet, valueForApi] of interpretation) {
        if (valueToSet === rawValue) {
          return valueForApi;
        }
      }
      return rawValue;
    }
  }

  function setValues(values) {
    Object.keys(data).forEach((apiName) => {
      const item = data[apiName];
      // console.log('setValue', valueName, prepareToSetValue(item, values[apiName]), item.itemType);
      setValue(valueName, prepareToSetValue(item, values[apiName]), item.itemType);
    });
  }

  function resetToDefaultValues() {
    const defaultValues = Object.keys(data).reduce((apiName) => ({ [apiName]: data[apiName].defaultValue }), {});
    setValues(defaultValues);
  }

  function preparedForApi() {
    return Object.keys(data).reduce((acc, key) => {
      const item = data[key];
      const { apiName, itemType } = item;
      return { ...acc, [apiName]: prepareApiValue(item, getValue(valueName, itemType)) };
    }, {});
  }
}

const manageEventOpts = initManageEventOpts();

manageEventOpts.addItem({ itemType: makeTextarea('#printHeaderMsg'), apiName: 'printHeaderMsg' });
manageEventOpts.addItem({ itemType: makeTextarea('#printFooterMsg'), apiName: 'printFooterMsg' });
manageEventOpts.addItem({ itemType: makeTextarea('#printConfirmMsg'), apiName: 'printConfirmMsg' });
manageEventOpts.addItem({ itemType: makeTextarea('#printConfirmMsgKiosk'), apiName: 'printConfirmMsgKiosk' });
manageEventOpts.addItem({ itemType: makeInputText('#regExpAttId'), apiName: 'regExpAttId' });
manageEventOpts.addItem({ itemType: makeInputText('#regVIPExpAttId'), apiName: 'regVIPExpAttId' });
manageEventOpts.addItem({ itemType: makeInputText('#shopDomain'), apiName: 'shopDomain' });
manageEventOpts.addItem({ itemType: makeInputText('#shopToken'), apiName: 'shopToken' });
manageEventOpts.addItem({ itemType: makeInputText('#shopifyOrderTags'), apiName: 'shopifyOrderTags' });
manageEventOpts.addItem({ itemType: makeInputText('#shopPlusId'), apiName: 'shopPlusId' });
manageEventOpts.addItem({
  itemType: makeCheckbox('#isUpsellProductsCheck'),
  apiName: 'isUpsellProductsCheck',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});
manageEventOpts.addItem({ itemType: makeCheckbox('#enabledShopComboRequired'), apiName: 'enabledShopComboRequired' });

manageEventOpts.addItem({ itemType: makeCheckbox('#showQRAtKioskCheckout'), apiName: 'showQRAtKioskCheckout' });
manageEventOpts.addItem({ itemType: makeInputText('#forceToIndexForTags'), apiName: 'forceToIndexForTags' });
manageEventOpts.addItem({ itemType: makeInputNumber('#selfieExpirationTime'), apiName: 'selfieExpirationTime' });
manageEventOpts.addItem({ itemType: makeInputNumber('#selfieAssociationTime'), apiName: 'selfieAssociationTime' });

manageEventOpts.addItem({ itemType: makeCheckbox('#enabledRedirectToWebapp'), apiName: 'enabledRedirectToWebapp' });
manageEventOpts.addItem({ itemType: makeCheckbox('#isDisableSelfies'), apiName: 'isDisableSelfies' });
manageEventOpts.addItem({ itemType: makeCheckbox('#isDisableLinkPhotos'), apiName: 'isDisableLinkPhotos' });
manageEventOpts.addItem({ itemType: vipToken, apiName: 'vipToken' });
manageEventOpts.addItem({ itemType: storiesPrintPool, apiName: 'storiesPrintPool' });

manageEventOpts.addItem({
  itemType: makeInputTags('#requiredTagsToGenerateStory'),
  apiName: 'requiredTagsToGenerateStory',
  defaultValue: '',
});

manageEventOpts.addItem({ itemType: makeInputNumber('#sessionExpires'), apiName: 'sessionExpires' });
manageEventOpts.addItem({ itemType: makeInputText('#zendeskKey'), apiName: 'zendeskKey' });

manageEventOpts.addItem({
  itemType: makeCheckbox('#enabledRegByFastQRShow'),
  apiName: 'webappRegType',
  defaultValue: 'default',
  interpretation: [
    [true, 'by-id-first'],
    [false, 'default'],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#enableContactCompletion'),
  apiName: 'enableContactCompletion',
});

manageEventOpts.addItem({
  itemType: makeInputText('#printingConfirmationText'),
  apiName: 'printingConfirmationText',
  defaultValue: DEFAULT_PRINTING_CONFIRMATION_TEXT,
});

manageEventOpts.addItem({ itemType: makeInputRange('#picSizes'), apiName: 'picSizes', defaultValue: DEFAULT_PIC_SIZE });

manageEventOpts.addItem({
  itemType: makeTextarea('#emailEnds'),
  apiName: 'emailEnds',
  defaultValue: DEFAULT_EMAIL_ENDS,
});

manageEventOpts.addItem({
  itemType: makeInputText('#notificationTopicKeyPickupLocation'),
  apiName: 'notificationTopicKeyPickupLocation',
  defaultValue: '',
});

manageEventOpts.addItem({
  itemType: makeInputNumber('#faceRecoConfidence'),
  apiName: 'faceRecoConfidence',
  defaultValue: 95,
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#disableEventLabel'),
  apiName: 'disableEventLabel',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#enableFavorites'),
  apiName: 'enableFavorites',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#enableEmailCollect'),
  apiName: 'enableEmailCollect',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#enableAttendeeReminder'),
  apiName: 'enableAttendeeReminder',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#enablePhotoUpl'),
  apiName: 'enablePhotoUpl',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#hideProductPrice'),
  apiName: 'hideProductPrice',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});
manageEventOpts.addItem({
  itemType: makeTextarea('#shopifyOrderTags'),
  apiName: 'shopifyOrderTags',
  defaultValue: '',
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#enableAttendeePhotoUpl'),
  apiName: 'enableAttendeePhotoUpl',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#kioskWatermarkEnable'),
  apiName: 'kioskWatermarkEnable',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#photoCashingForKioskEnabled'),
  apiName: 'photoCashingForKioskEnabled',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#isPhotoDelayCheckTags'),
  apiName: 'isPhotoDelayCheckTags',
  defaultValue: 0,
  interpretation: [
    [true, 1],
    [false, 0],
  ],
});
manageEventOpts.addItem({ itemType: makeInputText('#prodCollects'), apiName: 'prodCollects' });

manageEventOpts.addItem({ itemType: makeInputNumber('#uDPrice'), apiName: 'uDPrice' });

manageEventOpts.addItem({
  itemType: makeInputText('#evSupportLink'),
  apiName: 'evSupportLink',
  defaultValue: DEFAULT_EVENT_SUPPORT_LINK,
});

manageEventOpts.addItem({
  itemType: makeInputNumber('#evMultiplier1'),
  apiName: 'evMultiplier1',
  defaultValue: DEFAULT_EVENT_MULTIPLIER,
});
manageEventOpts.addItem({
  itemType: makeInputNumber('#evMultiplier2'),
  apiName: 'evMultiplier2',
  defaultValue: DEFAULT_EVENT_MULTIPLIER,
});

manageEventOpts.addItem({
  itemType: makeInputText('#logo-field .image-upload-field__src-input'),
  apiName: 'webappCustomLogoSrc',
});
manageEventOpts.addItem({
  itemType: makeInputText('#background-field .image-upload-field__src-input'),
  apiName: 'webappCustomBackgroundSrc',
});

manageEventOpts.addItem({
  itemType: makeInputText('#banner-top-field .image-upload-field__src-input'),
  apiName: 'webappBannerTopSrc',
});

manageEventOpts.addItem({
  itemType: makeInputText('#bannerTopClickLink'),
  apiName: 'webappBannerTopLink',
});

manageEventOpts.addItem({
  itemType: makeInputText('#banner-bottom-field .image-upload-field__src-input'),
  apiName: 'webappBannerBottomSrc',
});

manageEventOpts.addItem({
  itemType: makeInputText('#bannerBottomClickLink'),
  apiName: 'webappBannerBottomLink',
});

manageEventOpts.addItem({
  itemType: makeCheckbox('#webappSMS .image-upload-field__checkbox'),
  apiName: 'webappIsEnabledSMS',
});

manageEventOpts.addItem({
  itemType: makeInputText('#webappSMSText'),
  apiName: 'webappSMSText',
  defaultValue: `Hi {userName}, click here {url} to view your pictures.`,
});

manageEventOpts.addItem({
  itemType: makeInputText('#webappPurchaseRedirectUrl'),
  apiName: 'webappPurchaseRedirectUrl',
});

function buildGroupedSelect(list, selectedIdArray, selectId, selectedLabel, otherLabel) {

  const selectedIds = new Set((selectedIdArray || []).map(String));
  const selected = list.filter((item) => selectedIds.has(String(item.id)));
  const others = list.filter((item) => !selectedIds.has(String(item.id)));

  let html = `<select multiple="multiple" id="${selectId}">`;
  if (selected.length > 0) {
    html += `<optgroup label="${selectedLabel}">`;
    selected.forEach((item) => {
      html += `<option value=${item.id}>${item.name}</option>`;
    });
    html += '</optgroup>';
  }
  if (others.length > 0) {
    html += `<optgroup label="${otherLabel}">`;
    others.forEach((item) => {
      html += `<option value=${item.id}>${item.name}</option>`;
    });
    html += '</optgroup>';
  }
  html += '</select>';
  return html;
}

function drawPPTSelect(result, selectedEventPptId) {
  let option;
  const publicPPTList = result.public_ppt_list && result.public_ppt_list.length > 0 ? result.public_ppt_list : [];
  const privatePPTList = result.private_ppt_list && result.private_ppt_list.length > 0 ? result.private_ppt_list : [];
  const list = publicPPTList.concat(privatePPTList);
  const pptSelect = elId('occoTemplate');
  $('#occoTemplate').empty();
  pptSelect.options.length = 0;
  option = document.createElement('option');
  option.value = 0;
  option.text = '--Select Template--';
  pptSelect.add(option);
  for (let i = 0; i < list.length; i++) {
    option = document.createElement('option');
    option.value = list[i].id;
    option.text = list[i].name;
    pptSelect.add(option);
  }
  const selectedValue = selectedEventPptId || 0;
  $('#occoTemplate').val(selectedValue);
}

function drawRobotList(list, robotIdArray) {
  const html = buildGroupedSelect(list, robotIdArray, 'occoRobotSelect', 'Selected Robots', 'Other Robots');
  elId(
    'RobotListCont'
  ).innerHTML = `${html}<span class='event-desc'>Selected robots will be disconnected from previous event</span>`;
  const $select = $('#occoRobotSelect');
  $select.multipleSelect({
    width: '100%',
    placeholder: LANG.select_robots,
    selectAll: false,
    filter: true,
    hideOptgroupCheckboxes: true,
  });
  if (robotIdArray && robotIdArray.length > 0) {
    $select.multipleSelect('setSelects', robotIdArray);
    $select.multipleSelect('refresh');
  }
}

function setLoadingStateCloudProcessingList() {
  setLoaderToCont('processingList');
}

function drawProcessingList(list, processingIdArray) {
  const html = buildGroupedSelect(
    list,
    processingIdArray,
    'occoProcessingSelect',
    'Selected Pipelines',
    'Other Pipelines'
  );
  elId('processingList').innerHTML = html;
  const $select = $('#occoProcessingSelect');
  $select.multipleSelect({
    width: '100%',
    placeholder: LANG.select_pipelines,
    selectAll: false,
    filter: true,
    hideOptgroupCheckboxes: true,
  });
  if (processingIdArray && processingIdArray.length > 0) {
    $select.multipleSelect('setSelects', processingIdArray);
    $select.multipleSelect('refresh');
  }
}

function drawOrgList(list, containerId = 'OrgListCont') {
  let str =
    '<select class="form-control form-control-sm" id="occoOrgSelect"  onchange="occoEvent.occoOrgSelectChange()"  >';
  for (let i = 0; i < list.length; i++) {
    str += `<option value='${list[i].id}'>${list[i].name}</option>`;
  }
  str += '</select>';
  elId(containerId).innerHTML = str;
}

function OccoEventClass() {
  const self = this;
  let eventListCallback = null;
  this.event_status = null;
  this.EVENT_PARAMS = {};
  this.listeners = [];
  const STOCK_IMAGES_DIR = 'stockImages';
  const IGNORE_IMAGES_DIR = 'indexIgnoreFaces';

  initEventLanguageSettingsForm();

  this.initEventManager = function (callback) {
    eventListCallback = callback;
  };

  function filterEventList(dataList = []) {
    if (!EVENT_PRIVATE_API_KEY) return dataList;
    return dataList.filter((event) => event.private_api_key === EVENT_PRIVATE_API_KEY);
  }
  this.getEventFullDataByEventName = function (name, callback) {
    occoApi.eventFullDataRetrieve(name, (err, result) => {
      hideLoading();
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('eventFullDataRetrieve');
        return;
      }
      callback(result[0]);
    });
  };

  this.getEventListKiosks = function () {
    blockOverlay.hide();
    occoApi.eventListRetrieve(KEY_TYPE, KEY_VALUE, (err, result) => {
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('eventListRetrieve');
        return;
      }
      hideLoading();
      const eventList = filterEventList(result.dataList);
      if (eventList.length > 0) {
        eventList.forEach((event) => {
          setEvent(event.id, prepareEventParams(event));
        });
        if (isNeedToSaveSelectedEventId(eventList)) {
          selectedEventId.save(eventList[0].id);
        }
        if (eventListCallback) eventListCallback(eventList);
        if (eventList[0].organisation) {
          eventOrganisationDataStorage.storeEventOrganisationData(eventList[0].organisation);
        }
      } else {
        handleEmptyEventList();
      }
    });
  };

  this.getBasicEventList = function () {
    blockOverlay.hide();
    occoApi.eventBasicListRetrieve((err, result) => {
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('eventListRetrieve');
        return;
      }
      const eventList = filterEventList(result.dataList);
      if (eventList.length > 0) {
        eventList.forEach((event) => {
          setEvent(event.id, prepareEventBasicParams(event));
        });

        if (isNeedToSaveSelectedEventId(eventList)) {
          selectedEventId.save(eventList[0].id);
        }

        const selectedEventName = eventList.find((event) => event.id === getSelectedEventId())?.name;
        self.getEventFullDataByEventName(selectedEventName, (eventDataResult) => {
          if (eventDataResult.organisation) {
            eventOrganisationDataStorage.storeEventOrganisationData(eventDataResult.organisation);
          }
          self.updateEventParams(eventDataResult);
          self.finishSetData();
          if (eventListCallback) eventListCallback(result.dataList);
          if (elId('editEvent')) initEditEvent();
        });
      } else {
        handleEmptyEventList();
      }
    });
  };

  function handleEmptyEventList() {
    if (ALBUM_TYPES.isAttendeeAlbum) {
      elId('eventLogo').src = DEFAULT_LOGO;
    }
    if (ALBUM_TYPES.isOccoOwnerAlbum || ALBUM_TYPES.isEventOwnerAlbum) {
      setNoEvent();
    } else {
      setNoData();
    }
  }
  this.updateEventParams = function (event) {
    setEvent(event.id, prepareEventParams(event));
  };

  function prepareEventParams(event) {
    return {
      opts: safeJSONParse(event.opts, {}),
      notificationData: event.notification_data
        ? safeJSONParse(event.notification_data, null)
        : {
            cachedTopicsData: {},
            channels: [],
            topics: [],
            smsSettings: { from: '' },
          },
      shopifyShippingAddress:
        event.shopify_shipping_address && event.shopify_shipping_address !== 'null'
          ? JSON.parse(event.shopify_shipping_address)
          : {},
      eventId: event.id,
      eventshareId: event.owner_api_key,
      pvshareId: event.private_api_key,
      pubshareId: event.public_api_key,
      logo: event.logo_full_path,
      logoLink: event.logo_link,
      orgId: event.organisation_id,
      emailForReports: event.email_for_reports,
      streamAvMin: event.photo_stream_available_minutes,
      instantArchiveDays: event.instant_archive_days,
      photoAutoDeleteDays: event.photo_auto_delete_days,
      collectLeads: event.collect_leads,
      eventDesc: event.full_name,
      emptyAlbumText: event.empty_album_text,
      eventName: event.name,
      emailSubject: event.email_subject,
      fromAddress: event.email_from_address,
      fromName: event.email_from_name,
      emailBody: event.email_body_template,
      emailBodyShare: event.email_body_template_share,
      receiptEmailBody: event.receipt_email_body,
      sharingBodyTemplate: event.sharing_body_template,
      sharingVideoBodyTemplate: event.sharing_video_body_template,
      sharing360BodyTemplate: event.sharing_360_body_template,
      smsBody: event.sms_body_template,
      activeSMS: event.is_sms_enabled,
      leadParams: event.lead_params !== null ? JSON.parse(event.lead_params) : event.lead_params,
      activePrinter: event.is_photo_printer_active,
      enableFaceRec: event.enable_facial_recognition,
      printFromAllAlbums: event.print_from_all_albums,
      isPrintPoolEnabled: event.is_printer_pool_enabled,
      printerPoolList: event.printer_pool_name_list,
      printEveryPhoto: event.is_print_every_photo,
      hashTag: event.hash_tag ? event.hash_tag : '',
      robotIds: event.robot_id_array,
      processingIds: event.image_process_id_array,
      liveViewWatermark: event.live_view_watermark,
      protectorWatermark: event.protector_watermark,
      photoWatermark: event.photo_watermark,
      watermarkPtId: event.watermark_pt_id,
      stockImagesEnable: event.stock_images_enable,
      max_print_photos_count: event.max_print_photos_count,
      max_print_copies_count: event.max_print_copies_count,
      ppt_id_array: event.ppt_id_array,
      placeholderCount:
        event.place_holder_count && event.place_holder_count !== 'null'
          ? Number.parseInt(event.place_holder_count, 10)
          : null,
      secretCodeList: event.secret_code_list,
      paidEvent: +!event.is_free,
      unlocked: event.unlocked,
      dataUtcDiff: event.date_utc_diff_hours,
      eventLastUpdatedDate: event.updated_date,
    };
  }
  function prepareEventBasicParams(event) {
    return {
      eventId: event.id,
      eventName: event.name,
      eventDesc: event.full_name,
      orgId: event.organisation_id,
    };
  }
  /**
   * no event message
   */
  function setNoEvent() {
    const noDataCont = $('#noDataCont');
    noDataCont.html(
      `<div class='noData'>${LANG.no_event}<br> <a href='#' onclick='occoEvent.addEventAction()'>${LANG.add_event}</a></div>`
    );
  }
  /**
   * no photos message
   */
  function setNoData() {
    const noDataCont = $('#noDataCont');
    noDataCont.html(`<div class='noData'>${LANG.empty_album_default_text}</div>`);
  }
  /**
   * Add new Event
   */
  this.initAddEvent = function () {
    getOrgList();

    $('#stAvMinCheck').click(function () {
      $('#stAvMin').attr('disabled', !this.checked);
    });
    $('#isPhotoAutoDeleteCheck').click(function () {
      $('#photoAutoDeleteDays').attr('disabled', !this.checked);
    });
    $('#isInstantArchiveCheck').click(function () {
      $('#instantArchiveDays').attr('disabled', !this.checked);
    });
    $('#isPhotoDelayCheck').click(function () {
      $('#photoDelayMinutes').attr('disabled', !this.checked);
    });
    $('#isPhotoDelayCheckVip').click(function () {
      $('#photoDelayVipMinutes').attr('disabled', !this.checked);
    });
    $('#activeSMS').click(function () {
      const $smsBody = $('#smsBody');
      $smsBody.attr('disabled', !this.checked);
    });
    elId('addEvent').onclick = function () {
      self.addEventAction();
    };
    addDefaultPrintPoolWhenEnabled();
  };

  this.setStockImageTmbLoader = function (tr, on = false) {
    if (!tr) return;
    tr.find('#tmbLoader').prop('class', on ? 'stock-thumb' : 'stock-thumb-hidden');
    tr.find('#stock-image-tmb').css('display', on ? 'none' : 'block');
    tr.find('#uploadStockImageTmbButton').css('display', on ? 'none' : 'block');
  };
  this.setStockImageNewRowLoader = function (on = false) {
    let loader = '';
    let display = 'block';
    if (on) {
      loader = "<img src='./img/load.gif' alt=''/>";
      display = 'none';
    }
    elId('stockrow-loader').innerHTML = loader;
    elId('addStockImageButton').style.display = display;
  };

  /**
   * Adds a stock image row to the UI.
   * @param {Object} params
   * @param {string} params.imgUrl
   * @param {string} params.imgTmbUrl
   * @param {number} params.imgSize
   * @param {number} params.imgTmbSize
   * @param {string} [params.dateStart]
   * @param {string} [params.dateEnd]
   * @param {Object} [params.policy]
   * @param {string} [params.uid]
   * @param {string} [params.renderStyle]
   * @param {string} [params.placement]
   * @param {string|number|null} [params.position]
   * @param {string|null} [params.url]
   * @param {boolean} [params.availableForPurchase]
   * @param {boolean} [params.applyWatermark]
   * @param {boolean} [params.canBeDownloaded]
   * @param {boolean} [params.canBeMaximized]
   * @param {boolean} [params.showFavorites]
   * @param {string[]} [params.displayTargets]
   */
  this.addStockRow = function ({
    imgUrl,
    imgTmbUrl,
    imgSize,
    imgTmbSize,
    dateStart,
    dateEnd,
    policy = {},
    uid,
    renderStyle = '',
    placement = '',
    position = '',
    url = '',
    availableForPurchase = false,
    applyWatermark = false,
    canBeDownloaded = false,
    canBeMaximized = false,
    showFavorites = false,
    displayTargets = ['webapp', 'kiosk'],
  }) {
    createStockImageRow({
      imgUrl,
      imgTmbUrl,
      imgSize,
      imgTmbSize,
      dateStart,
      dateEnd,
      policy,
      uid,
      renderStyle,
      placement,
      position,
      url,
      availableForPurchase,
      applyWatermark,
      canBeDownloaded,
      canBeMaximized,
      showFavorites,
      displayTargets,
    });
  };

  this.removeStockImage = function (obj) {
    if (confirm('Delete this stock image?')) {
      obj.closest('.stock-image-card').remove();
    }
  };

  this.uploadStockImage = function () {
    const eventName = occoEvent.getSelectedEventParam('eventName');
    const uploadedFile = document.getElementById('stockImageUploadButton').files[0];
    if (!uploadedFile) return;
    self.setStockImageNewRowLoader(true);
    const imgSize = Math.floor(uploadedFile.size / 1024);
    const dir = `${STOCK_IMAGES_DIR}/${eventName}`;

    occoApi.stockImageUploadAccessRetrieve(dir, uploadedFile.name, false, (err, result) => {
      if (err) {
        self.setStockImageNewRowLoader(false);
        return alertMessagePopup(err.message_key);
      }
      uploadFileToS3(uploadedFile, result.fields.key, result.url, result.fields, handleSuccess, handleError);
    });

    function handleSuccess(imgUrl) {
      occoApi.createThumbnailForStockImage(dir, imgUrl, (err, result) => {
        let tmbImgUrl = null;
        let tmbImgSize = 0;

        if (!err) {
          tmbImgUrl = result.imgUrl;
          tmbImgSize = result.imgSize;
        }
        self.addStockRow({
          imgUrl,
          imgTmbUrl: tmbImgUrl,
          imgSize,
          imgTmbSize: tmbImgSize,
          renderStyle: 'thumb',
          placement: '',
          position: '',
          url: '',
          availableForPurchase: false,
          applyWatermark: false,
          canBeDownloaded: false,
          canBeMaximized: true,
          showFavorites: false,
          displayTargets: ['webapp', 'kiosk'],
        });
        self.setStockImageNewRowLoader(false);
      });
    }

    /**
     * Handles error during stock image upload
     * @param {{code: string, message: string}} error
     */
    function handleError(error) {
      if (error) {
        const msg = `<p><b>${error.code}</b></p> ${error.message}`;
        alertMessagePopup(msg);
        self.setStockImageNewRowLoader(false);
      }
    }
  };

  this.uploadStockImageTmb = function (tr) {
    const eventName = occoEvent.getSelectedEventParam('eventName');
    const uploadedFile = document.getElementById('stockImageUploadTmbButton').files[0];
    if (!uploadedFile) return;
    const imgSize = Math.floor(uploadedFile.size / 1024);
    self.setStockImageTmbLoader(tr, true);
    occoApi.stockImageUploadAccessRetrieve(
      `${STOCK_IMAGES_DIR}/${eventName}`,
      uploadedFile.name,
      true,
      (err, result) => {
        if (err) {
          self.setStockImageTmbLoader(tr);
          return alert(err.message_key);
        }
        uploadFileToS3(uploadedFile, result.fields.key, result.url, result.fields, (imgPath) => {
          if (err) {
            self.setStockImageTmbLoader(tr);
            return alert(err.message_key);
          }

          tr.find('#stock-image-tmb').prop('innerHTML', getThumbHTML(imgPath, imgSize));
          updateStockImageInfo(tr);
          self.setStockImageTmbLoader(tr);
          const obj = tr.find('#uploadStockImageTmbButton');
          console.log('uploadStockImageTmbButton = ', obj);
          console.log('uploadStockImageTmbButtonValue = ', obj.val());
          obj.html('change thumbnail');
        });
      }
    );
  };

  this.startUploadStockImageTmb = function (obj) {
    const tr = obj.closest('.stock-image-card');
    const inputTmb = document.getElementById('stockImageUploadTmbButton');
    inputTmb.addEventListener(
      'change',
      () => {
        this.uploadStockImageTmb(tr);
      },
      {
        once: true,
      }
    );
    inputTmb.click();
  };

  this.addIgnoreImagesRow = function (imgUrl, uid) {
    const tbody = $('#ignoreImageTBody');
    const uidRow = !uid || typeof uid === 'undefined' ? 'new' : uid;
    const imageId = `${uidRow}`; // Unique ID for each image
    const item = createIgnoreImageItem(imageId, imgUrl);
    tbody.append(toHtmlElement(item));
    tbody.justifiedGallery({
      border: 6,
      rowHeight: 180,
      lastRow: 'nojustify',
      margins: 8,
      captions: false,
      refreshTime: 250,
      cssAnimation: true,
      updateEntries: true,
      waitThumbnailsLoad: true,
      refreshSensitivity: 10,
    });

    function toHtmlElement(string) {
      const template = document.createElement('template');
      template.innerHTML = string.trim();
      return template.content.firstChild;
    }

    function createIgnoreImageItem(imageId, imgUrl) {
      return `
      <div id="ignore-image-${imageId}" class="ignore-image-item">
          <img class="image-item" id="imgId-${imageId}" src="${imgUrl}" alt="Image">
          <input type="checkbox" id="checkbox-${imageId}" class="ignore-image-checkbox" />
          <label for="checkbox-${imageId}">
          </label>
      </div>
    `;
    }
  };

  function getSelectedImageIds() {
    return Array.from(document.querySelectorAll('.ignore-image-checkbox:checked')).map((checkbox) =>
      checkbox.id.replace('checkbox-', '')
    );
  }

  this.deleteSelectedIgnoreImages = function () {
    if (confirm(LANG.delete_confirm)) {
      const selectedImageIds = getSelectedImageIds();
      if (selectedImageIds.length > 0) {
        const eventId = getSelectedEventId();
        occoApi.deleteIgnoreImages(selectedImageIds, eventId, (err) => {
          if (err) {
            alertMessagePopup(err.message_key);
            refreshPage('deleteIgnoreImage');
          } else {
            selectedImageIds.forEach((imageId) => {
              deleteUiElements(imageId);
            });

            // Update the disabled state of the "Delete Selected" button
            deleteBtn.disable(selectedImageIds);
          }
        });
      }
    }

    function deleteUiElements(idsToDelete) {
      const ids = Array.isArray(idsToDelete) ? idsToDelete : [idsToDelete];
      ids.forEach((id) => {
        $(`#ignore-image-${id}`).remove();
      });

      const tbody = $('#ignoreImageTBody');
      const remainingImages = tbody.find('.ignore-image-item');

      if (remainingImages.length === 0) {
        tbody.innerHeight(0);
      } else {
        tbody.justifiedGallery({
          border: 6,
          rowHeight: 180,
          lastRow: 'nojustify',
          margins: 8,
          captions: false,
          refreshTime: 250,
          cssAnimation: true,
          updateEntries: true,
          waitThumbnailsLoad: true,
          refreshSensitivity: 10,
        });
      }
    }
  };

  this.uploadIgnoreImages = function () {
    const eventName = occoEvent.getSelectedEventParam('eventName');
    const uploadedFile = document.getElementById('ignoreImageUploadButton').files[0];
    if (!uploadedFile) return;
    const dir = `${eventName}/${IGNORE_IMAGES_DIR}`;

    occoApi.ignoreImageUploadAccessRetrieve(dir, uploadedFile.name, (err, result) => {
      if (err) {
        return alert(err.message_key);
      }
      uploadFileToS3(uploadedFile, result.fields.key, result.url, result.fields, (imgUrl) => {
        if (err) {
          return alert(err.message_key);
        }

        const eventId = getSelectedEventId();
        occoApi.createIgnoreImage(eventId, imgUrl, (e, res) => {
          console.log(res);

          if (e) {
            return alert(e.message_key);
          }
          self.addIgnoreImagesRow(imgUrl, res.id);
        });
      });
    });
  };

  this.getIgnoreImageList = function (eventId) {
    if (!eventId) return;
    occoApi.ignoreImageListRetrieve(eventId, (err, result) => {
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('ignoreImageListRetrieve');
        return;
      }
      drawIgnoreImageList(result);
    });

    function drawIgnoreImageList(arg) {
      $('#ignoreImageTBody').prop('innerHTML', '');
      if (!arg) {
        return;
      }

      let rows = [];

      if (Array.isArray(arg)) {
        rows = arg;
      } else {
        rows.push(arg);
      }

      for (const row of rows) {
        self.addIgnoreImagesRow(row.full_path, row.id);
      }
    }
  };

  this.selectedImageRemove = function () {
    const deleteSelectedButton = document.getElementById('deleteSelectedButton');
    if (deleteSelectedButton) {
      const deleteButtonDisabled = getSelectedImageIds().length === 0;
      deleteBtn.disable(deleteButtonDisabled);
    }
  };

  this.addEventAction = function () {
    self.event_status = 'add';
    $('.nav-tabs a[href="#general"]').tab('show');
    initWaterMarkControls();
    initWebappControls();
    initNotificationSettings();
    const uploadedImageFolder = new Date().valueOf(); // random number
    $('#eventEditModal').modal('show');
    elId('eventNameCont').style.display = 'none';
    // elId("deleteEventCont").style.display = "none";
    elId('wLiveViewPathId').value = fromUrlFilename(DEFAULT_WATERMARK);
    elId('wProtPathId').value = fromUrlFilename(DEFAULT_WATERMARK);
    $('#occoWatermarkTemplatesSelect').prop('selectedIndex', 0);
    elId('wLiveViewSentPhotoId').value = fromUrlFilename(DEFAULT_WATERMARK);
    elId('eventImageId').value = fromUrlFilename(DEFAULT_LOGO);
    elId('slideBgImageId').value = fromUrlFilename(DEFAULT_SLIDESHOW_BG);
    $('input:radio[name=watTempType]')[1].checked = true;
    _controlTemplateMode($("input:radio[name ='watTempType']:checked").val());
    elId('hiddenwLiveViewPathId').value = DEFAULT_WATERMARK;
    elId('hiddenwLiveViewSentPhotoId').value = DEFAULT_WATERMARK;
    elId('hiddeneventImageId').value = DEFAULT_LOGO;
    elId('hiddenwProtPathId').value = DEFAULT_WATERMARK;
    $('#addEventForm')[0].reset();
    elId('wImage1').src = DEFAULT_LOGO;
    elId('wImage2').src = DEFAULT_WATERMARK;
    elId('wImage3').src = DEFAULT_WATERMARK;
    elId('wProtImage').src = DEFAULT_WATERMARK;
    elId('slideBgImage').src = DEFAULT_SLIDESHOW_BG;
    elId('viewWaterEnable').checked = true;
    elId('photoWaterEnable').checked = true;
    elId('paidEventCheck').checked = false;
    _disablePaidEvent();
    $('#occoRobotSelect').multipleSelect('refresh');
    $('#occoProcessingSelect').multipleSelect('refresh');
    $('#stAvMin').attr('disabled', 'true');
    $('#stAvMinCheck').prop('checked', false);
    $('#stAvMinCheck').click(function () {
      $('#stAvMin').attr('disabled', !this.checked);
    });
    $('#stAvMin').value = '';

    $('#photoAutoDeleteDays').attr('disabled', 'true');
    $('#isPhotoAutoDeleteCheck').prop('checked', false);
    $('#isPhotoAutoDeleteCheck').click(function () {
      $('#photoAutoDeleteDays').attr('disabled', !this.checked);
    });
    $('#photoAutoDeleteDays').value = '';

    $('#isUpsellProductsCheck').prop('checked', false);

    $('#instantArchiveDays').attr('disabled', 'true');
    $('#isInstantArchiveCheck').prop('checked', false);
    $('#isInstantArchiveCheck').click(function () {
      $('#instantArchiveDays').attr('disabled', !this.checked);
    });
    $('#instantArchiveDays').value = '';

    const $photoDelayMinutes = $('#photoDelayMinutes');
    $photoDelayMinutes.attr('disabled', 'true');
    const $isPhotoDelayCheck = $('#isPhotoDelayCheck');
    $isPhotoDelayCheck.prop('checked', false);
    $isPhotoDelayCheck.click(function () {
      $photoDelayMinutes.attr('disabled', !this.checked);
    });
    $photoDelayMinutes.val('');

    const $photoDelayVipMinutes = $('#photoDelayVipMinutes');
    $photoDelayVipMinutes.attr('disabled', 'true');
    const $isPhotoDelayCheckVip = $('#isPhotoDelayCheckVip');
    $isPhotoDelayCheckVip.prop('checked', false);
    $isPhotoDelayCheckVip.click(function () {
      $photoDelayVipMinutes.attr('disabled', !this.checked);
    });
    $photoDelayVipMinutes.val('');

    $('#isPhotoDelayCheckTags').prop('checked', false);
    $('#photoDelayTags').importTags('');
    $('#photoDelayTagsMinutes').val('');
    $('#photoDelayTagsCont').addClass('disable-cont');

    $('#photoCashingForKioskEnabled').prop('checked', false);
    $('#activePrinter').prop('checked', false);
    $('#printFromAllAlbumsCheck').prop('checked', false);
    $('#printerPoolEnable').prop('checked', false);
    $('#printPoolCont').addClass('disable-cont');
    $('#printPoolName').importTags('');
    $('#activeSMS').prop('checked', false);
    $('#disableEventLabel').prop('checked', false);
    $('#enableEmailCollect').prop('checked', true);
    $('#enableAttendeeReminder').prop('checked', false);
    $('#hideProductPrice').prop('checked', false);
    $('#enablePhotoUpl').prop('checked', false);
    $('#enableAttendeePhotoUpl').prop('checked', false);
    $('#enableFavorites').prop('checked', false);
    $('#enableFaceRec').prop('checked', false);
    $('#stockImagesEnable').prop('checked', false);
    $('#kioskWatermarkEnable').prop('checked', false);
    $('#printEveryPhoto').prop('checked', false);
    $('#eventDesc').removeClass('input-error');
    $('#fromAddress').removeClass('input-error');
    $('#fromName').removeClass('input-error');
    $('#emailBody').removeClass('input-error');
    $('#emailBodyShare').removeClass('input-error');
    $('#receiptEmailBody').removeClass('input-error');
    $('#sharingBodyTemplate').removeClass('input-error');
    $('#sharingVideoBodyTemplate').removeClass('input-error');
    $('#sharing360BodyTemplate').removeClass('input-error');

    resetStockImagesList()

    const $smsBody = $('#smsBody');
    $smsBody.removeClass('input-error');
    $smsBody.prop('disabled', true);
    $smsBody.val(SMS_TEMP);
    const obj_copies_count = elId('max_print_copies_count');
    const obj_photos_count = elId('max_print_photos_count');
    obj_copies_count.value = DEFAULT_COPIES;
    obj_photos_count.value = DEFAULT_PRINT;
    obj_copies_count.disabled = true;
    obj_photos_count.disabled = true;
    $('input:radio[name=photoDistRadio]')[0].checked = true;
    elId('fromAddress').value = DEFAULT_FROM_ADDRESS;
    elId('fromName').value = DEFAULT_NAME;
    elId('emailForReports').value = '';
    elId('emailSubject').value = DEFAULT_EMAILSUBJECT;
    elId('emailBody').value = EMAIL_TEMP;
    elId('emailBodyShare').value = EMAIL_SHARING_TEMP;
    elId('receiptEmailBody').value = RECEIPT_EMAIL_BODY_TEMP;
    elId('sharingBodyTemplate').value = SHARING_BODY_TEMPLATE_HTML;
    elId('sharingVideoBodyTemplate').value = SHARING_VIDEO_BODY_TEMPLATE_HTML;
    elId('sharing360BodyTemplate').value = SHARING_360_BODY_TEMPLATE_HTML;
    $('.bar1').css('width', `${0}%`);
    elId('OrgListCont').style.display = '';
    elId('logoClickLink').value = DEFAULT_LOGO_LINK;
    elId('evSupportLink').value = DEFAULT_EVENT_SUPPORT_LINK;
    elId('printingConfirmationText').value = DEFAULT_PRINTING_CONFIRMATION_TEXT;
    elId('evMultiplier1').value = DEFAULT_EVENT_MULTIPLIER;
    elId('evMultiplier2').value = DEFAULT_EVENT_MULTIPLIER;
    elId('uDPrice').value = '';
    elId('prodCollects').value = '';
    emptyShopifyShippingAddressFields();
    elId('attPhotoImgPrTag').value = '';
    elId('attPhotoImgMaxWidth').value = '';
    elId('attPhotoImgMaxHeight').value = '';
    applyEventLanguageSettingsToForm();
    $('#trackerSnippet').val(' ');
    resetAndEmptyInputs([
      elId('shopifyApiKey'),
      elId('shopifyApiPassword'),
      elId('stripeSecretKey'),
      elId('occoApiToken'),
      elId('monobankToken'),
      elId('rtrApiToken'),
      elId('squareApiToken'),
      elId('soundPaymentsUsername'),
      elId('soundPaymentsPassword'),
    ]);
    const occoOrgSelect = elId('occoOrgSelect');
    if (occoOrgSelect) {
      occoOrgSelect.disabled = '';
      occoOrgSelect.selectedIndex = '0';

      const s = elId('occoOrgSelect');
      const selectedIndex = s.options[s.selectedIndex];
      const orgId = selectedIndex.value;
      self.getPPTList(orgId, null);
      getRobotList(orgId, null);
      getProcessingList(null);
    }
    fillTimeZoneList();
    $('#stAvMin').val('');
    $('#photoAutoDeleteDays').val('');
    $('#instantArchiveDays').val('');
    elId('editEventAction').style.display = 'none';
    elId('copyEventAction').style.display = 'none';
    elId('saveEventAction').style.display = 'none';
    $('#unlockEventCont').html('');
    addNewUnlockCode();
    const addEventAction = elId('addEventAction');
    addEventAction.style.display = 'block';
    addEventAction.onclick = function () {
      addEvent();
    };
    uploadImage('direct-upload1', 'wImage1', 1, 'eventImageId', uploadedImageFolder);
    uploadImage('direct-upload2', 'wImage2', 2, 'wLiveViewPathId', uploadedImageFolder);
    uploadImage('direct-upload3', 'wImage3', 3, 'wLiveViewSentPhotoId', uploadedImageFolder);
    uploadImage(
      'direct-upload-slideBg',
      'slideBgImage',
      4,
      'slideBgImageId',
      Math.floor(Math.random() * 10001),
      true,
      'slideshowBG/'
    );
    uploadImage('direct-upload2-protector', 'wProtImage', 5, 'wProtPathId', uploadedImageFolder);
  };

  function emptyShopifyShippingAddressFields() {
    resetAndEmptyInputs([
      elId('shopifyFirstName'),
      elId('shopifyLastName'),
      elId('shopifyAddress1'),
      elId('shopifyAddress2'),
      elId('shopifyCountry'),
      elId('shopifyState'),
      elId('shopifyCity'),
      elId('shopifyZip'),
      elId('shopifyCompany'),
      elId('shopifyPhoneNumber'),
    ]);
  }

  function addEvent() {
    const s = elId('occoOrgSelect');
    const selectedIndex = s.options[s.selectedIndex];
    const org_id = selectedIndex.value;
    const $addEventActionButton = $('#addEventAction');

    const eventDesc = elId('eventDesc').value;
    const mainData = getFullDataForCreateEditEvent();
    if (mainData === undefined) {
      return;
    }
    if (eventDesc != '') {
      $addEventActionButton.button('loading');
      occoApi.eventCreate(mainData, org_id, (err, resp) => {
        if (err) {
          return alertMessagePopup(err.message_key);
        }
        $addEventActionButton.button('reset');
        $('#saveEventAction').css('display', 'none');
        $('#saveEventAction').off();
        $('#eventEditModal').modal('hide');
        if (mainData.email_from_address !== 'me@occo.me') {
          const content = `<div>
                        <h6>You have modified your from email address. An email has been sent by Amazon Web Services to your email address for verification.</h6><br>
                        <button type="button" class="btn btn-primary btn-lg btn-ss"  data-dismiss="modal" >Close</button>
                        `;
          customPopUp.html(content);
          customPopUp.show();
        }
        uploadSettingInShareBucket(mainData);
        self.getBasicEventList();
        window.onbeforeunload = null;
      });
    } else {
      alertMessagePopup(LANG.valid_data);
    }
  }

  function addDefaultPrintPoolWhenEnabled() {
    $('#printerPoolEnable').change(function () {
      if (this.checked && elId('printPoolName').value === '') {
        $('#printPoolName').importTags('Default');
      }
    });
  }

  function initEditEvent() {
    editEventActivatePrinter(+occoEvent.getSelectedEventParam('activePrinter'));
    elId('editEvent').onclick = function () {
      editEventButtonControl.disable();
      activateRequestForm();
      editEventActivatePrinter(+occoEvent.getSelectedEventParam('activePrinter'));
      self.event_status = 'edit';
      $('.nav-tabs a[href="#general"]').tab('show');
      initWaterMarkControls();
      initWebappControls();
      initNotificationSettings(occoEvent.getSelectedEventParam('notificationData'));
      const id = getSelectedEventId();
      self.getWatermarkTemplateList(2, self.drawWatermarkTemplatesList);
      $('#addEventForm')[0].reset();
      const name = unescape(self.getSelectedEventParam('eventName'));
      const opts = self.getSelectedEventParam('opts');
      const shopifyShippingAddress = self.getSelectedEventParam('shopifyShippingAddress');
      const uploadedImageFolder = new Date().valueOf(); // random number
      const src = self.getSelectedEventParam('logo');
      const orgId = self.getSelectedEventParam('orgId');
      const streamAvMin = self.getSelectedEventParam('streamAvMin');
      const photoAutoDeleteDays = self.getSelectedEventParam('photoAutoDeleteDays');
      const instantArchiveDays = self.getSelectedEventParam('instantArchiveDays');
      const eventDesc = unescape(self.getSelectedEventParam('eventDesc'));
      const emailSubject = unescape(self.getSelectedEventParam('emailSubject'));
      const fromAddress = unescape(self.getSelectedEventParam('fromAddress'));
      const fromName = unescape(self.getSelectedEventParam('fromName'));
      const emailForReports = self.getSelectedEventParam('emailForReports');
      const emailBody = unescape(self.getSelectedEventParam('emailBody'));
      const emailBodyShare = unescape(self.getSelectedEventParam('emailBodyShare'));
      const receiptEmailBody = unescape(self.getSelectedEventParam('receiptEmailBody'));
      const sharingBodyTemplate = unescape(self.getSelectedEventParam('sharingBodyTemplate'));
      const sharingVideoBodyTemplate = unescape(self.getSelectedEventParam('sharingVideoBodyTemplate'));
      const sharing360BodyTemplate = unescape(self.getSelectedEventParam('sharing360BodyTemplate'));
      const smsBody = unescape(self.getSelectedEventParam('smsBody'));
      const activeSMS = +self.getSelectedEventParam('activeSMS');
      const activePrinter = +self.getSelectedEventParam('activePrinter');
      const printFromAllAlbums = +self.getSelectedEventParam('printFromAllAlbums');
      const isPrintPoolEnabled = +self.getSelectedEventParam('isPrintPoolEnabled');
      const printerPoolList = self.getSelectedEventParam('printerPoolList');
      const printEveryPhoto = +self.getSelectedEventParam('printEveryPhoto');
      const hashTag = self.getSelectedEventParam('hashTag');
      const liveViewWatermark = self.getSelectedEventParam('liveViewWatermark');
      const photoWatermark = self.getSelectedEventParam('photoWatermark');
      const watermarkPtId = self.getSelectedEventParam('watermarkPtId');
      const robotIds = self.getSelectedEventParam('robotIds');
      const collectLeads = self.getSelectedEventParam('collectLeads');
      const max_print_copies_count = +self.getSelectedEventParam('max_print_copies_count');
      const max_print_photos_count = +self.getSelectedEventParam('max_print_photos_count');
      const logoLink = self.getSelectedEventParam('logoLink');
      const leadParams = self.getSelectedEventParam('leadParams');
      const paidEvent = self.getSelectedEventParam('paidEvent');
      const protectorWatermark = self.getSelectedEventParam('protectorWatermark');
      const secretCodeList = self.getSelectedEventParam('secretCodeList');
      const enableFaceRec = +self.getSelectedEventParam('enableFaceRec');
      const stockImagesEnable = self.getSelectedEventParam('stockImagesEnable');
      const dateUtcDiffHours = self.getSelectedEventParam('dataUtcDiff');
      $('#eventEditModal').modal('show');
      elId('eventNameCont').style.display = 'block';
      // NOTE: Functional for delete event
      // elId("deleteEventCont").style.display = "block";
      // elId("deleteEventCont").onclick = function () {
      //     if (confirm(LANG.delete_message)) {
      //         deleteEvent();
      //     }
      // };
      $('#occoRobotSelect').multipleSelect('refresh');
      $('#occoProcessingSelect').multipleSelect('refresh');
      elId('wLiveViewPathId').value = fromUrlFilename(DEFAULT_WATERMARK);
      elId('wLiveViewSentPhotoId').value = fromUrlFilename(DEFAULT_WATERMARK);
      elId('wProtPathId').value = DEFAULT_WATERMARK;
      elId('eventImageId').value = fromUrlFilename(DEFAULT_LOGO);
      elId('slideBgImageId').value = fromUrlFilename(DEFAULT_SLIDESHOW_BG);
      elId('wImage1').src = DEFAULT_LOGO;
      elId('wImage2').src = DEFAULT_WATERMARK;
      elId('wImage3').src = DEFAULT_WATERMARK;
      elId('wProtImage').src = DEFAULT_WATERMARK;
      elId('slideBgImage').src = DEFAULT_SLIDESHOW_BG;
      $('#eventDesc').removeClass('input-error');
      $('#fromAddress').removeClass('input-error');
      $('#fromName').removeClass('input-error');
      $('#emailBody').removeClass('input-error');
      $('#emailBodyShare').removeClass('input-error');
      $('#receiptEmailBody').removeClass('input-error');
      $('#sharingBodyTemplate').removeClass('input-error');
      $('#sharingVideoBodyTemplate').removeClass('input-error');
      $('#sharing360BodyTemplate').removeClass('input-error');
      const $smsBody = $('#smsBody');
      $smsBody.removeClass('input-error');
      $smsBody.val(SMS_TEMP);
      elId('viewWaterEnable').checked = true;
      elId('photoWaterEnable').checked = true;
      elId('paidEventCheck').checked = false;
      _disablePaidEvent();
      $('#stAvMinCheck').prop('checked', false);
      $('#isPhotoAutoDeleteCheck').prop('checked', false);
      $('#isUpsellProductsCheck').prop('checked', false);
      $('#isInstantArchiveCheck').prop('checked', false);
      $('#activePrinter').prop('checked', false);
      $('#printFromAllAlbumsCheck').prop('checked', false);
      $('#printerPoolEnable').prop('checked', false);
      $('#printPoolName').importTags('');
      $('#activeSMS').prop('checked', false);
      $('#enableFaceRec').prop('checked', false);
      $('#stockImagesEnable').prop('checked', false);
      $('#printEveryPhoto').prop('checked', false);
      $('#isPhotoDelayCheck').prop('checked', false);
      $('#addEventForm')[0].reset();
      elId('eventName').value = name;
      elId('qrCodeDownload').setAttribute('event-name', name);
      elId('logoClickLink').value = '';
      elId('emailForReports').value = '';
      resetAndEmptyInputs([
        elId('shopifyApiKey'),
        elId('shopifyApiPassword'),
        elId('stripeSecretKey'),
        elId('occoApiToken'),
        elId('monobankToken'),
        elId('rtrApiToken'),
        elId('squareApiToken'),
        elId('soundPaymentsUsername'),
        elId('soundPaymentsPassword'),
      ]);
      $('#trackerSnippet').val(getTrackerSnippetForEvent(name));
      self.getEventSecureParams(name);
      emptyShopifyShippingAddressFields();
      for (const field in shopifyShippingAddress) {
        // console.log('field: ', field);
        if (shopifyShippingAddress[field]) {
          // console.log('exist field: ', field, shopifyShippingAddress[field]);
          elId(field).value = shopifyShippingAddress[field];
        }
      }

      let robotIdArray = [];
      const processingIdArray = self.getEventPipelineIds();

      if (robotIds !== '' && robotIds !== 'null' && robotIds != null) {
        robotIdArray = robotIds.split(',');
      }

      Promise.all([getRobotList(orgId, robotIdArray), getProcessingList(processingIdArray)])
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          editEventButtonControl.enable();
        });

      if (eventDesc != '' && eventDesc != 'null' && eventDesc != null) {
        elId('eventDesc').value = eventDesc;
      }
      fillTimeZoneList(dateUtcDiffHours);

      const obj_stockImagesEnable = $('#stockImagesEnable');
      obj_stockImagesEnable.prop('checked', stockImagesEnable);

      if (collectLeads) {
        $('input:radio[name=photoDistRadio]')[0].checked = true;
      } else {
        $('input:radio[name=photoDistRadio]')[1].checked = true;
      }

      if (emailSubject != '' && emailSubject != 'null' && emailSubject != null) {
        elId('emailSubject').value = emailSubject;
      }
      if (fromAddress != '' && fromAddress != 'null' && fromAddress != null) {
        elId('fromAddress').value = fromAddress;
      }
      if (fromName != '' && fromName != 'null' && fromName != null) {
        elId('fromName').value = fromName;
      }
      if (emailBody != '' && emailBody != 'null' && emailBody != null) {
        elId('emailBody').value = emailBody;
      }
      if (emailBodyShare != '' && emailBodyShare != 'null' && emailBodyShare != null) {
        elId('emailBodyShare').value = emailBodyShare;
      } else {
        elId('emailBodyShare').value = EMAIL_SHARING_TEMP;
      }
      if (receiptEmailBody != '' && receiptEmailBody != 'null' && receiptEmailBody != null) {
        elId('receiptEmailBody').value = receiptEmailBody;
      } else {
        elId('receiptEmailBody').value = RECEIPT_EMAIL_BODY_TEMP;
      }
      if (sharingBodyTemplate != '' && sharingBodyTemplate != 'null' && sharingBodyTemplate != null) {
        elId('sharingBodyTemplate').value = sharingBodyTemplate;
      } else {
        elId('sharingBodyTemplate').value = SHARING_BODY_TEMPLATE_HTML;
      }
      if (sharingVideoBodyTemplate != '' && sharingVideoBodyTemplate != 'null' && sharingVideoBodyTemplate != null) {
        elId('sharingVideoBodyTemplate').value = sharingVideoBodyTemplate;
      } else {
        elId('sharingVideoBodyTemplate').value = SHARING_VIDEO_BODY_TEMPLATE_HTML;
      }
      if (sharing360BodyTemplate != '' && sharing360BodyTemplate != 'null' && sharing360BodyTemplate != null) {
        elId('sharing360BodyTemplate').value = sharing360BodyTemplate;
      } else {
        elId('sharing360BodyTemplate').value = SHARING_360_BODY_TEMPLATE_HTML;
      }
      if (smsBody != '' && smsBody != 'null' && smsBody != null) {
        $smsBody.val(smsBody);
      }
      if (hashTag != '' && hashTag != 'null' && hashTag != null) {
        elId('eventHtag').value = hashTag;
      }
      if (liveViewWatermark && liveViewWatermark != 'null') {
        elId('wImage2').src = normaliseUrl(liveViewWatermark);
        elId('wLiveViewPathId').value = fromUrlFilename(liveViewWatermark);
        elId('hiddenwLiveViewPathId').value = liveViewWatermark;
      } else {
        elId('viewWaterEnable').checked = false;
        _disableViewWaterMark();
      }

      if ((watermarkPtId && watermarkPtId != 'null') || (photoWatermark && photoWatermark != 'null')) {
        elId('photoWaterEnable').checked = true;

        if (watermarkPtId && watermarkPtId != 'null') {
          $('input:radio[name=watTempType]')[0].checked = true;
        } else if (photoWatermark && photoWatermark != 'null') {
          $('input:radio[name=watTempType]')[1].checked = true;
          elId('wImage3').src = normaliseUrl(photoWatermark);
          elId('wLiveViewSentPhotoId').value = fromUrlFilename(photoWatermark);
          elId('hiddenwLiveViewSentPhotoId').value = photoWatermark;
        }
      } else {
        elId('photoWaterEnable').checked = false;
        _disablePhotoWaterMark();
      }
      $('#unlockEventCont').html('');
      if (paidEvent && paidEvent != 'null' && paidEvent === 1) {
        _enablePaidEvent();
        elId('paidEventCheck').checked = true;
        elId('wProtImage').src = normaliseUrl(protectorWatermark);
        elId('wProtPathId').value = fromUrlFilename(protectorWatermark);
        elId('hiddenwProtPathId').value = protectorWatermark;
      } else {
        elId('paidEventCheck').checked = false;
        _disablePaidEvent();
      }
      if (secretCodeList) {
        setUnlockCodes(secretCodeList);
      }

      const mode = $("input:radio[name ='watTempType']:checked").val();
      _controlTemplateMode(mode);
      if (src && src != 'null' && src != DEFAULT_LOGO) {
        elId('wImage1').src = normaliseUrl(src);
        elId('eventImageId').value = fromUrlFilename(src);
        elId('hiddeneventImageId').value = src;
      }
      if (streamAvMin !== '' && streamAvMin != 'null' && streamAvMin != null) {
        $('#stAvMin').prop('disabled', false);
        $('#stAvMin').val(streamAvMin);
        $('#stAvMinCheck').prop('checked', true);
      } else {
        $('#stAvMin').val('');
      }

      if (photoAutoDeleteDays !== '' && photoAutoDeleteDays != 'null' && photoAutoDeleteDays != null) {
        $('#photoAutoDeleteDays').prop('disabled', false);
        $('#photoAutoDeleteDays').val(photoAutoDeleteDays);
        $('#isPhotoAutoDeleteCheck').prop('checked', true);
      } else {
        $('#photoAutoDeleteDays').val('');
      }
      const optIsUpsellProductsCheck = opts.isUpsellProductsCheck;
      $('#isUpsellProductsCheck').prop('checked', optIsUpsellProductsCheck && optIsUpsellProductsCheck === 1);

      if (instantArchiveDays !== '' && instantArchiveDays != 'null' && instantArchiveDays != null) {
        $('#instantArchiveDays').prop('disabled', false);
        $('#instantArchiveDays').val(instantArchiveDays);
        $('#isInstantArchiveCheck').prop('checked', true);
      } else {
        $('#instantArchiveDays').val('');
      }
      if (logoLink != '' && logoLink != 'null' && logoLink != null) {
        elId('logoClickLink').value = logoLink;
      }

      elId('emailForReports').value = emailForReports;

      const obj_copies_count = elId('max_print_copies_count');
      const obj_photos_count = elId('max_print_photos_count');
      const obj_printEveryPhoto = $('#printEveryPhoto');
      if (printEveryPhoto === 1) {
        obj_printEveryPhoto.prop('checked', true);
      } else {
        obj_printEveryPhoto.prop('checked', false);
      }
      const obj_printer = $('#activePrinter');
      obj_copies_count.value = max_print_copies_count;
      obj_photos_count.value = max_print_photos_count;
      if (activePrinter === 1) {
        obj_printer.prop('checked', true);
        obj_copies_count.disabled = false;
        obj_photos_count.disabled = false;
      } else {
        obj_printer.prop('checked', false);
        obj_copies_count.disabled = true;
        obj_photos_count.disabled = true;
      }

      const $printFromAllAlbumsCheck = $('#printFromAllAlbumsCheck');
      if (printFromAllAlbums === 1) {
        $printFromAllAlbumsCheck.prop('checked', true);
      } else {
        $printFromAllAlbumsCheck.prop('checked', false);
      }

      const $printerPoolEnable = $('#printerPoolEnable');
      if (isPrintPoolEnabled === 1) {
        $printerPoolEnable.prop('checked', true);
        $('#printPoolCont').removeClass('disable-cont');
        if (printerPoolList) {
          $('#printPoolName').importTags(printerPoolList);
        }
      } else {
        $printerPoolEnable.prop('checked', false);
        $('#printPoolCont').addClass('disable-cont');
      }

      const obj_enableFaceRec = $('#enableFaceRec');
      if (enableFaceRec === 1) {
        obj_enableFaceRec.prop('checked', true);
      } else {
        obj_enableFaceRec.prop('checked', false);
      }
      const activeSMSCheckbox = $('#activeSMS');
      const smsBodyTextbox = elId('smsBody');
      if (activeSMS === 1) {
        activeSMSCheckbox.prop('checked', true);
        smsBodyTextbox.disabled = false;
      } else {
        activeSMSCheckbox.prop('checked', false);
        smsBodyTextbox.disabled = true;
      }

      const slideBgImageVal = opts.slideshowBg;
      if (slideBgImageVal && slideBgImageVal != 'null' && slideBgImageVal != DEFAULT_SLIDESHOW_BG) {
        elId('slideBgImage').src = normaliseUrl(slideBgImageVal);
        elId('eventImageId').value = fromUrlFilename(slideBgImageVal);
        elId('hiddenslideBgImageId').value = slideBgImageVal;
      }

      const opt_enableAttendeePhotoUpl = opts.enableAttendeePhotoUpl;
      if (opt_enableAttendeePhotoUpl && opt_enableAttendeePhotoUpl === 1) {
        _enableAttPhotoUpl();
      } else {
        _disableAttPhotoUpl();
      }

      const { photoDelayMinutes } = opts;
      if (photoDelayMinutes !== '' && photoDelayMinutes != 'null' && photoDelayMinutes != null) {
        $('#photoDelayMinutes').prop('disabled', false);
        $('#photoDelayMinutes').val(photoDelayMinutes);
        $('#isPhotoDelayCheck').prop('checked', true);
      } else {
        $('#photoDelayMinutes').val('');
      }

      const { photoDelayVipMinutes } = opts;
      if (photoDelayVipMinutes !== '' && photoDelayVipMinutes !== 'null' && photoDelayVipMinutes != null) {
        $('#photoDelayVipMinutes').prop('disabled', false);
        $('#photoDelayVipMinutes').val(photoDelayVipMinutes);
        $('#isPhotoDelayCheckVip').prop('checked', true);
      } else {
        $('#photoDelayVipMinutes').val('');
      }

      if (opts.isPhotoDelayCheckTags === 1) {
        $('#photoDelayTagsCont').removeClass('disable-cont');
        $('#photoDelayTagsMinutes').prop('disabled', false);
      } else {
        $('#photoDelayTagsCont').addClass('disable-cont');
        $('#photoDelayTagsMinutes').prop('disabled', true);
      }
      const { photoDelayTagsMinutes } = opts;
      if (photoDelayTagsMinutes !== '' && photoDelayTagsMinutes !== 'null' && photoDelayTagsMinutes != null) {
        $('#photoDelayTagsMinutes').val(photoDelayTagsMinutes);
      };

      const { photoDelayTags } = opts;
      if (photoDelayTags !== '' && photoDelayTags !== 'null' && photoDelayTags != null) {
        $('#photoDelayTags').importTags(photoDelayTags);
      }

      setValue('options', self.optionsStoriesPrintPool(), storiesPrintPool);
      // console.log('opts', opts);
      manageEventOpts.setValues(opts);
      applyEventLanguageSettingsToForm(getEventLanguageSettings(opts));

      initCustomAttendeeId();
      setDefaultLogoSrc(opts.webappCustomLogoSrc);
      setDefaultBackgroundSrc(opts.webappCustomBackgroundSrc);
      setDefaultBannerTopSrc(opts.webappBannerTopSrc);
      setDefaultBannerBottomSrc(opts.webappBannerBottomSrc);
      enableSMSForm(opts.webappIsEnabledSMS);

      /* Start Request Form Tab params */
      const $showCompanyNameCheck = $('#showCompanyName');
      $showCompanyNameCheck.prop('checked', false);
      if (
        leadParams !== null &&
        leadParams.show_company_input_text !== '' &&
        leadParams.show_company_input_text !== null
      ) {
        if (leadParams.show_company_input_text === 1) {
          $showCompanyNameCheck.prop('checked', true);
        } else {
          $showCompanyNameCheck.prop('checked', false);
        }
      }
      const $showPhoneNumberCheck = $('#showPhoneNumber');
      $showPhoneNumberCheck.prop('checked', false);
      if (leadParams !== null && leadParams.show_phone_input_text !== '' && leadParams.show_phone_input_text !== null) {
        if (leadParams.show_phone_input_text === 1) {
          $showPhoneNumberCheck.prop('checked', true);
        } else {
          $showPhoneNumberCheck.prop('checked', false);
        }
      }
      const $showAgreeCheckCheck = $('#showAgreeDrawWin');
      $showAgreeCheckCheck.prop('checked', false);
      if (leadParams !== null && leadParams.show_agree_checkbox !== '' && leadParams.show_agree_checkbox !== null) {
        if (leadParams.show_agree_checkbox === 1) {
          $showAgreeCheckCheck.prop('checked', true);
        } else {
          $showAgreeCheckCheck.prop('checked', false);
        }
      }
      const $pleaseReadTextInput = $('#pleaseReadText');
      $pleaseReadTextInput.removeClass('input-error');
      $pleaseReadTextInput.val(LANG.please_read_text);
      if (leadParams !== null && leadParams.please_read_text !== '' && leadParams.please_read_text !== null) {
        $pleaseReadTextInput.val(leadParams.please_read_text);
      }
      const $privacyPolicyLinkInput = $('#privacyPolicyLink');
      $privacyPolicyLinkInput.removeClass('input-error');
      $privacyPolicyLinkInput.val(PRIVACY_POLICY_LINK);
      if (leadParams !== null && leadParams.privacy_policy_link !== '' && leadParams.privacy_policy_link !== null) {
        $privacyPolicyLinkInput.val(leadParams.privacy_policy_link);
      }
      /* End Request Form Tab params */

      $('#occoOrgSelect').val(orgId);
      elId('OrgListCont').style.display = '';
      $('#occoOrgSelect').attr('disabled', 'disabled');

      elId('addEventAction').style.display = 'none';
      elId('saveEventAction').style.display = 'none';
      const editEventAction = elId('editEventAction');
      editEventAction.style.display = 'block';
      editEventAction.onclick = function () {
        updateEvent();

        document.body.style.pointerEvents = 'none';

        setTimeout(() => {
          document.body.style.pointerEvents = 'auto';
        }, 6000);
      };
      $('#copyEventAction').text(LANG.duplicate_event);
      const copyEventAction = elId('copyEventAction');
      copyEventAction.style.display = 'block';
      copyEventAction.onclick = function () {
        copyEvent();
      };
      getStockImageList(id);
      self.getIgnoreImageList(id);
      addDefaultPrintPoolWhenEnabled();
      uploadImage('direct-upload1', 'wImage1', 1, 'eventImageId', uploadedImageFolder);
      uploadImage('direct-upload2', 'wImage2', 2, 'wLiveViewPathId', uploadedImageFolder);
      uploadImage('direct-upload3', 'wImage3', 3, 'wLiveViewSentPhotoId', uploadedImageFolder);
      uploadImage(
        'direct-upload-slideBg',
        'slideBgImage',
        4,
        'slideBgImageId',
        Math.floor(Math.random() * 10001),
        true,
        'slideshowBG/'
      );
      uploadImage('direct-upload2-protector', 'wProtImage', 5, 'wProtPathId', uploadedImageFolder);
    };

    elId('changeEventOrg').onclick = function () {
      const orgId = self.getSelectedEventParam('orgId');
      drawOrgList(organisationData.data(), 'changeOrgSelectCont');
      $('#changeOrgSelectCont select').val(orgId);
      $('#changeOrgModal').modal('show');
    };

    elId('changeOrgAction').onclick = function () {
      const eventId = getSelectedEventId();
      const newOrgId = elId('changeOrgSelectCont').querySelector('select').value;
      if (!globalThis.confirm(LANG.change_org_confirm_message)) {
        return;
      }
      const $btn = $('#changeOrgAction');
      $btn.button('loading');
      occoApi.eventChangeOrg(eventId, newOrgId, (err) => {
        $btn.button('reset');
        if (err) {
          alertMessagePopup(err.message_key);
          return;
        }
        $('#changeOrgModal').modal('hide');
        self.getBasicEventList();
      });
    };

    function updateEvent() {
      const id = getSelectedEventId();
      const $editEventActionButton = $('#editEventAction');

      /* Start Update Request Form Tab params */
      const pleaseReadText = elId('pleaseReadText').value;
      const $privacyPolicyLinkInput = $('#privacyPolicyLink');
      let privacyPolicyLinkValue = $privacyPolicyLinkInput.val();
      if (!isURL(privacyPolicyLinkValue)) {
        if (privacyPolicyLinkValue === '') {
          privacyPolicyLinkValue = PRIVACY_POLICY_LINK;
        } else {
          $privacyPolicyLinkInput.addClass('input-error');
          alertMessagePopup(LANG.valid_url);
          return;
        }
      } else {
        $privacyPolicyLinkInput.removeClass('input-error');
      }

      const leadParamsUpdate = {};
      leadParamsUpdate.show_company_input_text = +elId('showCompanyName').checked;
      leadParamsUpdate.show_phone_input_text = +elId('showPhoneNumber').checked;
      leadParamsUpdate.show_agree_checkbox = +elId('showAgreeDrawWin').checked;
      leadParamsUpdate.please_read_text = pleaseReadText === '' ? LANG.please_read_text : pleaseReadText;
      leadParamsUpdate.privacy_policy_link = privacyPolicyLinkValue;
      const leadParamsStr = JSON.stringify(leadParamsUpdate);

      const eventDesc = elId('eventDesc').value;
      const mainData = getFullDataForCreateEditEvent();
      if (mainData === undefined) {
        return;
      }
      /* End Update Request Form Tab params */
      if (eventDesc !== '') {
        $editEventActionButton.button('loading');
        occoApi.eventUpdate(mainData, id, leadParamsStr, (err) => {
          if (err) {
            if (err.message_key === 'event_was_updated_by_another_user') {
              if (confirm(LANG.event_was_updated_by_another_user)) {
                self.getBasicEventList();
                $('#eventEditModal').modal('hide');
                $editEventActionButton.button('reset');
              } else {
                $editEventActionButton.button('reset');
              }
              return;
            }
            return alertMessagePopup(err.message_key);
          }
          $editEventActionButton.button('reset');
          $('#eventEditModal').modal('hide');
          if (mainData.email_from_address !== self.getSelectedEventParam('fromAddress')) {
            const content = `<div>
                        <h6>You have modified your from email address. An email has been sent by Amazon Web Services to your new email address for verification.</h6><br>
                        <button type="button" id="verifyFromEmail" class="btn btn-primary btn-lg btn-ss"  data-dismiss="modal" >Close</button>
                        `;
            customPopUp.html(content);
            customPopUp.show();
          }
          uploadSettingInShareBucket(mainData);
          self.getBasicEventList();
          window.onbeforeunload = null;
        });
      } else {
        alertMessagePopup(LANG.valid_data);
      }
    }

    /**
     * Event for CANON
     * Looks like it's not used anymore
     */
    function activateRequestForm() {
      const eventId = occoEvent.getSelectedEventParam('eventId');
      if (eventId === 191 || eventId === 209 || eventId === 10) {
        // CANON and Testing Photo album events
        $('#requestForm-tab').css('display', 'block');
      } else {
        $('#requestForm-tab').css('display', 'none');
      }
    }
  }

  function collectShopifyShippingAddressForAddOrEditEvent() {
    const shopify_shipping_address_params = {};
    shopify_shipping_address_params.shopifyAddress1 = elId('shopifyAddress1').value;
    shopify_shipping_address_params.shopifyAddress2 = elId('shopifyAddress2').value;
    shopify_shipping_address_params.shopifyCountry = elId('shopifyCountry').value;
    shopify_shipping_address_params.shopifyState = elId('shopifyState').value;
    shopify_shipping_address_params.shopifyCity = elId('shopifyCity').value;
    shopify_shipping_address_params.shopifyZip = elId('shopifyZip').value;
    shopify_shipping_address_params.shopifyCompany = elId('shopifyCompany').value;
    shopify_shipping_address_params.shopifyPhoneNumber = elId('shopifyPhoneNumber').value;
    shopify_shipping_address_params.shopifyFirstName = elId('shopifyFirstName').value;
    shopify_shipping_address_params.shopifyLastName = elId('shopifyLastName').value;
    return JSON.stringify(shopify_shipping_address_params);
  }

  function collectOptsForAddOrEditEvent() {
    const $evSupportLinkEl = $('#evSupportLink');
    let evSupportLinkVal = $evSupportLinkEl.val();
    evSupportLinkVal = evSupportLinkVal ? evSupportLinkVal.trim() : evSupportLinkVal;
    if (evSupportLinkVal != null && evSupportLinkVal != '' && !isURL(evSupportLinkVal)) {
      $evSupportLinkEl.addClass('input-error');
      alertMessagePopup(LANG.valid_url);
      return;
    }
    $evSupportLinkEl.removeClass('input-error');

    const $webappPurchaseRedirectUrlEl = $('#webappPurchaseRedirectUrl');
    const webappPurchaseRedirectUrlVal = $webappPurchaseRedirectUrlEl.val();
    if (webappPurchaseRedirectUrlVal && !isURL(webappPurchaseRedirectUrlVal)) {
      $webappPurchaseRedirectUrlEl.addClass('input-error');
      alertMessagePopup(LANG.valid_url);
      return;
    }
    $webappPurchaseRedirectUrlEl.removeClass('input-error');

    const languageSettings = collectEventLanguageSettingsFromForm();
    if (!languageSettings) {
      return;
    }

    let photoDelayMinutes = +elId('photoDelayMinutes').value;
    const isPhotoDelayCheck = +$('#isPhotoDelayCheck')[0].checked;
    if (!isPhotoDelayCheck) {
      photoDelayMinutes = null;
    }
    let photoDelayVipMinutes = +elId('photoDelayVipMinutes').value;
    const isPhotoDelayCheckVip = +$('#isPhotoDelayCheckVip')[0].checked;
    if (!isPhotoDelayCheckVip) {
      photoDelayVipMinutes = null;
    }

    const isPhotoDelayCheckTags = +elId('isPhotoDelayCheckTags').checked;
    const photoDelayTagsMinutes = isPhotoDelayCheckTags ? +elId('photoDelayTagsMinutes').value : null;
    const photoDelayTags = isPhotoDelayCheckTags ? elId('photoDelayTags').value : null;

    const opts_params_update = {};

    if (elId('enableAttendeePhotoUpl').checked) {
      opts_params_update.attPhotoImgPrTag = elId('attPhotoImgPrTag').value;
      opts_params_update.attPhotoImgMaxWidth = elId('attPhotoImgMaxWidth').value;
      opts_params_update.attPhotoImgMaxHeight = elId('attPhotoImgMaxHeight').value;
    }
    opts_params_update.slideshowBg = elId('hiddenslideBgImageId').value;
    opts_params_update.photoDelayMinutes = photoDelayMinutes;
    opts_params_update.photoDelayVipMinutes = photoDelayVipMinutes;
    opts_params_update.photoDelayTagsMinutes = photoDelayTagsMinutes;
    opts_params_update.photoDelayTags = photoDelayTags;

    const allOpts = { ...opts_params_update, ...manageEventOpts.preparedForApi() };
    allOpts.languageSettings = languageSettings;

    const tags =
      allOpts.requiredTagsToGenerateStory.trim() === '' ? [] : allOpts.requiredTagsToGenerateStory.split(',');
    allOpts.lookForTagsInImages = {
      tags,
      actions: [
        {
          kind: 'createAStory',
          poolName: allOpts.storiesPrintPool,
          tags,
        },
      ],
    };
    // console.log('allOpts', allOpts);

    return allOpts;
  }

  function printingTabCollectAndValidateDataAddOrEditEvent() {
    const printing_data = {};
    printing_data.is_photo_printer_active = +elId('activePrinter').checked;
    printing_data.print_from_all_albums = +elId('printFromAllAlbumsCheck').checked;
    printing_data.is_printer_pool_enabled = +elId('printerPoolEnable').checked;
    printing_data.is_print_every_photo = +elId('printEveryPhoto').checked;
    let printerPoolListVal = null;
    if (printing_data.is_printer_pool_enabled === 1) {
      if (elId('printPoolName') && elId('printPoolName').value === '') {
        printerPoolListVal = ['Default'];
      } else {
        printerPoolListVal = elId('printPoolName').value.split(',');
      }
    }

    const max_print_copies_count = +elId('max_print_copies_count').value;
    const ppt_id = elId('occoTemplate').value;
    const ppt_id_array = [];
    if (ppt_id && ppt_id != '0' && ppt_id != 'null') {
      ppt_id_array.push(ppt_id);
    }
    if (max_print_copies_count < 1 || max_print_copies_count > MAX_PRINT_COUNT) {
      alertMessagePopup(LANG.photos_copy_count_error.replace(/<limit>/g, MAX_PRINT_COUNT));
      return;
    }
    const max_print_photos_count = +elId('max_print_photos_count').value;
    if (max_print_photos_count < 1 || max_print_photos_count > MAX_PRINT_COUNT) {
      alertMessagePopup(LANG.per_request_count_error.replace(/<limit>/g, MAX_PRINT_COUNT));
      return;
    }
    printing_data.max_print_photos_count = max_print_photos_count;
    printing_data.max_print_copies_count = max_print_copies_count;
    printing_data.ppt_id_array = ppt_id_array;
    printing_data.printer_pool_name_list = printerPoolListVal;
    return printing_data;
  }

  function emailTabCollectAndValidateDataAddOrEditEvent() {
    const email_data = {};
    email_data.email_subject = elId('emailSubject').value;
    email_data.email_from_address = elId('fromAddress').value;
    email_data.email_from_name = elId('fromName').value;
    if (email_data.email_from_address == '') {
      $('#fromAddress').addClass('input-error');
      alertMessagePopup(LANG.address_required);
      return;
    }
    $('#fromAddress').removeClass('input-error');

    if (email_data.email_from_name == '') {
      $('#fromName').addClass('input-error');
      alertMessagePopup(LANG.name_required);
      return;
    }
    $('#fromName').removeClass('input-error');

    email_data.email_body_template = elId('emailBody').value;
    if (email_data.email_body_template == '') {
      $('#emailBody').addClass('input-error');
      alertMessagePopup(LANG.body_required);
      return;
    }
    $('#emailBody').removeClass('input-error');

    if (!isTemplate(email_data.email_body_template)) {
      $('#emailBody').addClass('input-error');
      alertMessagePopup(LANG.body_error);
      return;
    }
    $('#emailBody').removeClass('input-error');

    email_data.email_body_template_share = elId('emailBodyShare').value;
    if (email_data.email_body_template_share == '') {
      $('#emailBodyShare').addClass('input-error');
      alertMessagePopup(LANG.body_required);
      return;
    }
    $('#emailBodyShare').removeClass('input-error');

    if (!isTemplateShare(email_data.email_body_template_share)) {
      $('#emailBodyShare').addClass('input-error');
      alertMessagePopup(LANG.body_share_error);
      return;
    }
    $('#emailBodyShare').removeClass('input-error');

    email_data.receipt_email_body = elId('receiptEmailBody').value;
    if (email_data.receipt_email_body == '') {
      $('#receiptEmailBody').addClass('input-error');
      alertMessagePopup(LANG.receipt_email_body_required);
      return;
    }
    $('#receiptEmailBody').removeClass('input-error');

    if (!isReceiptEmailBody(email_data.receipt_email_body)) {
      $('#receiptEmailBody').addClass('input-error');
      alertMessagePopup(LANG.receipt_email_body_error);
      return;
    }
    $('#receiptEmailBody').removeClass('input-error');

    return email_data;
  }

  function sharingTabCollectAndValidateDataAddOrEditEvent() {
    const sharing_data = {};
    sharing_data.sharing_body_template = elId('sharingBodyTemplate').value;
    if (sharing_data.sharing_body_template == '') {
      $('#sharingBodyTemplate').addClass('input-error');
      alertMessagePopup(LANG.sharing_body_required);
      return;
    }
    $('#sharingBodyTemplate').removeClass('input-error');

    sharing_data.sharing_video_body_template = elId('sharingVideoBodyTemplate').value;
    if (sharing_data.sharing_video_body_template == '') {
      $('#sharingVideoBodyTemplate').addClass('input-error');
      alertMessagePopup(LANG.sharing_video_body_required);
      return;
    }
    $('#sharingVideoBodyTemplate').removeClass('input-error');

    sharing_data.sharing_360_body_template = elId('sharing360BodyTemplate').value;
    if (sharing_data.sharing_360_body_template == '') {
      $('#sharing360BodyTemplate').addClass('input-error');
      alertMessagePopup(LANG.sharing_360_body_required);
      return;
    }
    $('#sharing360BodyTemplate').removeClass('input-error');

    return sharing_data;
  }

  function generalTabCollectAndValidateDataAddOrEditEvent() {
    const generalData = {};
    generalData.full_name = elId('eventDesc').value;
    if (generalData.full_name == '') {
      $('#eventDesc').addClass('input-error');
      alertMessagePopup(LANG.title_required);
      return;
    }
    $('#eventDesc').removeClass('input-error');

    generalData.empty_album_text = LANG.empty_album_default_text;

    generalData.logo_full_path = elId('hiddeneventImageId').value;
    generalData.robot_id_array = $('#occoRobotSelect').multipleSelect('getSelects');
    generalData.image_process_id_array = $('#occoProcessingSelect').multipleSelect('getSelects');
    generalData.hash_tag = elId('eventHtag').value;
    generalData.enable_facial_recognition = +elId('enableFaceRec').checked;
    generalData.date_utc_diff_hours = parseInt($('#dateUtcDiffHours').val(), 10);
    generalData.email_for_reports = elId('emailForReports').value;

    const $logoLinkEl = $('#logoClickLink');
    let logoLink = $logoLinkEl.val();
    logoLink = logoLink ? logoLink.trim() : logoLink;
    if (logoLink != null && logoLink != '' && !isURL(logoLink)) {
      $logoLinkEl.addClass('input-error');
      alertMessagePopup(LANG.valid_url);
      return;
    }
    $logoLinkEl.removeClass('input-error');

    generalData.logo_link = logoLink;
    generalData.event_last_updated_date = self.getSelectedEventParam('eventLastUpdatedDate');
    return generalData;
  }

  function smsTabCollectAndValidateDataAddOrEditEvent() {
    const sms_data = {
      sms_body_template: elId('smsBody').value,
      is_sms_enabled: +elId('activeSMS').checked,
    };
    if (sms_data.is_sms_enabled === 1) {
      if (sms_data.sms_body_template == '') {
        $('#smsBody').addClass('input-error');
        alertMessagePopup(LANG.sms_body_required);
        return;
      }
      $('#smsBody').removeClass('input-error');

      if (!isTemplateSMS(sms_data.sms_body_template)) {
        $('#smsBody').addClass('input-error');
        alertMessagePopup(LANG.sms_body_error);
        return;
      }
      $('#smsBody').removeClass('input-error');
    }
    return sms_data;
  }

  function photoTabCollectAndValidateDataAddOrEditEvent(actionType) {
    const photo_data = {
      photo_stream_available_minutes: +elId('stAvMin').value,
      photo_auto_delete_days: +elId('photoAutoDeleteDays').value,
      instant_archive_days: +elId('instantArchiveDays').value,
      collect_leads: $("input:radio[name ='photoDistRadio']:checked").val(),
    };
    const stAvMinCheck = +$('#stAvMinCheck')[0].checked;
    if (!stAvMinCheck) {
      photo_data.photo_stream_available_minutes = null;
    }
    if (
      stAvMinCheck &&
      (photo_data.photo_stream_available_minutes < 1 ||
        photo_data.photo_stream_available_minutes > MAX_PHOTO_STREAM_AVAILABLE_MINUTES)
    ) {
      alertMessagePopup(
        LANG.max_photo_stream_avl_minutes_error.replace(/<limit>/g, MAX_PHOTO_STREAM_AVAILABLE_MINUTES)
      );
      return;
    }
    const isPhotoAutoDeleteCheck = +$('#isPhotoAutoDeleteCheck')[0].checked;
    if (!isPhotoAutoDeleteCheck) {
      photo_data.photo_auto_delete_days = null;
    } else {
      const oldPhotoAutoDeleteDays = self.getSelectedEventParam('photoAutoDeleteDays');
      const bool = actionType == 'create' ? true : oldPhotoAutoDeleteDays != photoAutoDeleteDays;
      if (bool && !confirm(LANG.auto_delete_photo_warn_massage)) {
        return;
      }
    }
    if (
      isPhotoAutoDeleteCheck &&
      (photo_data.photo_auto_delete_days < MIN_PHOTO_AUTO_DELETE_DAYS ||
        photo_data.photo_auto_delete_days > MAX_PHOTO_AUTO_DELETE_DAYS)
    ) {
      let msg = LANG.photo_delete_days_value_error.replace(/<limit>/g, MAX_PHOTO_AUTO_DELETE_DAYS);
      msg = msg.replace(/<min-limit>/g, MIN_PHOTO_AUTO_DELETE_DAYS);
      alertMessagePopup(msg);
      return;
    }
    const isInstantArchiveCheck = +$('#isInstantArchiveCheck')[0].checked;
    if (!isInstantArchiveCheck) {
      photo_data.instant_archive_days = null;
    }
    if (
      isPhotoAutoDeleteCheck &&
      isInstantArchiveCheck &&
      photo_data.photo_auto_delete_days <= photo_data.instant_archive_days
    ) {
      const msg = LANG.photo_delete_days_archive_error;
      alertMessagePopup(msg);
      return;
    }

    return photo_data;
  }

  function paidTabCollectAndValidateDataAddOrEditEvent() {
    return {
      is_free: +!elId('paidEventCheck').checked,
      protector_watermark: elId('hiddenwProtPathId').value,
      secret_code_list: getUnlockCodeList(),
    };
  }

  function watermarkTabCollectAndValidateDataAddOrEditEvent() {
    const activePhotoWater = elId('photoWaterEnable').checked;
    const watTempType = $("input:radio[name ='watTempType']:checked").val();
    return {
      live_view_watermark: elId('hiddenwLiveViewPathId').value,
      watermark_pt_id:
        activePhotoWater && watTempType === 'temp-mode' ? elId('occoWatermarkTemplatesSelect').value : null,
      photo_watermark: activePhotoWater && watTempType === 'img-mode' ? elId('hiddenwLiveViewSentPhotoId').value : null,
    };
  }

  function getFullDataForCreateEditEvent() {
    const optsParamsStr = collectOptsForAddOrEditEvent();
    const generalData = generalTabCollectAndValidateDataAddOrEditEvent();
    const emailData = emailTabCollectAndValidateDataAddOrEditEvent();
    const smsData = smsTabCollectAndValidateDataAddOrEditEvent();
    const watermarkData = watermarkTabCollectAndValidateDataAddOrEditEvent();
    const photoData = photoTabCollectAndValidateDataAddOrEditEvent();
    const printingData = printingTabCollectAndValidateDataAddOrEditEvent();
    const paidData = paidTabCollectAndValidateDataAddOrEditEvent();
    const sharingData = sharingTabCollectAndValidateDataAddOrEditEvent();
    const notificationData = getNotificationData();

    if (!isValidAllData()) return;
    const eventSecureData = collectSecurePropertiesForAddOrEditEvent();
    return $.extend(
      {
        opts: optsParamsStr,
        shopify_shipping_address: collectShopifyShippingAddressForAddOrEditEvent(),
        notification_data: notificationData,
      },
      generalData,
      emailData,
      smsData,
      watermarkData,
      photoData,
      printingData,
      paidData,
      sharingData,
      eventSecureData,
      stockTabCollectAndValidateDataAddOrEditEvent()
    );

    function isValidAllData() {
      return ![
        optsParamsStr,
        generalData,
        emailData,
        smsData,
        watermarkData,
        photoData,
        printingData,
        paidData,
        sharingData,
        isValidSMSText(),
      ].includes(undefined);
    }
  }

  // NOTE: functional for delete event
  function deleteEvent() {
    const eventId = getSelectedEventId();
    occoApi.eventDelete(EVENT_OWNER_API_KEY, eventId, (err, result) => {
      if (err) {
        return alertMessagePopup(err.message_key);
      }
      $('#eventEditModal').modal('hide');
      self.getBasicEventList();
    });
  }

  function copyEvent() {
    elId('eventDesc').value += '_copy';
    elId('eventNameCont').style.display = 'none';
    removeRobotSelection();
    $('#editEventAction').css('display', 'none');
    $('#copyEventAction').css('display', 'none');
    $('#saveEventAction').css('display', 'block');
    $('#saveEventAction').click(() => {
      addEvent();
    });

    function removeRobotSelection() {
      const $occoRobotSelect = $('#occoRobotSelect');
      $occoRobotSelect.find('option').remove();
      $occoRobotSelect.multipleSelect('refresh');
    }
  }

  this.printingPoolControl = {
    // NOTE: Modal with choose in which photo need to print and on what print pool
    initPrintingPoolControls() {
      const $printPoolCont = $('#printPoolCont');
      $printPoolCont.addClass('disable-cont');
      elId('printerPoolEnable').onclick = function () {
        if (this.checked === true) {
          $printPoolCont.removeClass('disable-cont');
        } else {
          $printPoolCont.addClass('disable-cont');
        }
      };
      activateMultiTagsInput('printPoolName');
      activateMultiRegiredTagsToCreateStoryInput('requiredTagsToGenerateStory');
    },
  };

  this.photoTagsDelayControl = {
    initPhotoTagsDelayControls() {
      const $photoDelayTagsCont = $('#photoDelayTagsCont');
      const $photoDelayTagsMinutes = $('#photoDelayTagsMinutes');
      const checkbox = elId('isPhotoDelayCheckTags');
      $photoDelayTagsMinutes.attr('disabled', 'true');
      $photoDelayTagsMinutes.val('');
      $photoDelayTagsCont.addClass('disable-cont');

      checkbox.onclick = () => {
        $photoDelayTagsMinutes.attr('disabled', !checkbox.checked);
        $photoDelayTagsCont.toggleClass('disable-cont', !checkbox.checked);
      };

      activateMultiTagsInput('photoDelayTags');
    },
  };

  function initCustomAttendeeId() {
    const $regExpAttId = $('#regExpAttId');
    const $regVIPExpAttId = $('#regVIPExpAttId');

    handle();
    $regExpAttId.on('keyup', handle);

    function handle() {
      if ($regExpAttId.val().trim().length === 0) {
        $regVIPExpAttId.prop('disabled', true);
      } else if ($regVIPExpAttId.prop('disabled')) {
        $regVIPExpAttId.prop('disabled', false);
      }
    }
  }

  function initWaterMarkControls() {
    _enableViewWaterMark();
    _enablePhotoWaterMark();
    $('input:radio[name ="watTempType"]').on('click', function (e) {
      _controlTemplateMode(this.value);
    });
    elId('viewWaterEnable').onclick = function () {
      if (this.checked === true) {
        _enableViewWaterMark();
      } else {
        _disableViewWaterMark();
      }
    };
    elId('photoWaterEnable').onclick = function () {
      if (this.checked === true) {
        _enablePhotoWaterMark();
      } else {
        _disablePhotoWaterMark();
      }
    };
    elId('viewLogoEnable').onclick = function () {
      if (this.checked === true) {
        _enableViewLogo();
      } else {
        _disableViewLogo();
      }
    };
    elId('paidEventCheck').onclick = function () {
      if (this.checked === true) {
        _enablePaidEvent();
      } else {
        _disablePaidEvent();
      }
    };
    elId('enableAttendeePhotoUpl').onclick = function () {
      if (this.checked === true) {
        $('#enableAttendeePhotoUpl').prop('checked', true);
        _enableAttPhotoUpl();
      } else {
        $('#enableAttendeePhotoUpl').prop('checked', false);
        _disableAttPhotoUpl();
      }
    };

    function _enableViewLogo() {
      elId('eventImageId').value = fromUrlFilename(DEFAULT_LOGO);
      elId('hiddeneventImageId').value = DEFAULT_LOGO;
      elId('wImage1').src = DEFAULT_LOGO;
      elId('wImageCont').className = '';
    }

    function _disableViewLogo() {
      elId('eventImageId').value = '';
      elId('hiddeneventImageId').value = '';
      elId('wImage1').src = '';
      elId('wImageCont').className = 'disable-cont';
    }

    function _enableViewWaterMark() {
      elId('wLiveViewPathId').value = fromUrlFilename(DEFAULT_WATERMARK);
      elId('hiddenwLiveViewPathId').value = DEFAULT_WATERMARK;
      elId('wImage2').src = DEFAULT_WATERMARK;
      elId('viewWaterCont').className = '';
    }

    function _enablePhotoWaterMark() {
      elId('wLiveViewSentPhotoId').value = fromUrlFilename(DEFAULT_WATERMARK);
      elId('hiddenwLiveViewSentPhotoId').value = DEFAULT_WATERMARK;
      elId('wImage3').src = DEFAULT_WATERMARK;
      elId('photoWaterCont').className = '';
    }
  }

  function _disableViewWaterMark() {
    elId('wLiveViewPathId').value = '';
    elId('hiddenwLiveViewPathId').value = '';
    elId('wImage2').src = '';
    elId('viewWaterCont').className = 'disable-cont';
  }

  function _disablePhotoWaterMark() {
    elId('wLiveViewSentPhotoId').value = '';
    elId('hiddenwLiveViewSentPhotoId').value = '';
    elId('wImage3').src = '';
    elId('photoWaterCont').className = 'disable-cont';
  }

  function _enableAttPhotoUpl() {
    elId('attPhotoImgPrTag').disabled = '';
    elId('attPhotoImgMaxWidth').disabled = '';
    elId('attPhotoImgMaxHeight').disabled = '';
    if (self.event_status === 'edit') {
      const opts = self.getSelectedEventParam('opts');
      elId('attPhotoImgPrTag').value =
        opts.attPhotoImgPrTag !== undefined ? opts.attPhotoImgPrTag : elId('attPhotoImgPrTag').value;
      elId('attPhotoImgMaxWidth').value =
        opts.attPhotoImgMaxWidth !== undefined ? opts.attPhotoImgMaxWidth : elId('attPhotoImgMaxWidth').value;
      elId('attPhotoImgMaxHeight').value =
        opts.attPhotoImgMaxHeight !== undefined ? opts.attPhotoImgMaxHeight : elId('attPhotoImgMaxHeight').value;
    }
  }

  function _disableAttPhotoUpl() {
    elId('attPhotoImgPrTag').disabled = 'disabled';
    elId('attPhotoImgMaxWidth').disabled = 'disabled';
    elId('attPhotoImgMaxHeight').disabled = 'disabled';
    elId('attPhotoImgPrTag').value = '';
    elId('attPhotoImgMaxWidth').value = '';
    elId('attPhotoImgMaxHeight').value = '';
  }

  function _enablePaidEvent() {
    elId('wProtPathId').value = fromUrlFilename(DEFAULT_LOGO);
    elId('hiddenwProtPathId').value = DEFAULT_LOGO;
    elId('wProtImage').src = DEFAULT_LOGO;
    elId('protWaterCont').className = '';
  }

  function _disablePaidEvent() {
    elId('wProtPathId').value = '';
    elId('hiddenwProtPathId').value = '';
    elId('wProtImage').src = '';
    elId('protWaterCont').className = 'disable-cont';
  }

  function _controlTemplateMode(mode) {
    switch (mode) {
      case 'temp-mode':
        elId('templateModeCont').className = '';
        elId('imageModeCont').className = 'disable-cont';
        break;
      case 'img-mode':
        elId('templateModeCont').className = 'disable-cont';
        elId('imageModeCont').className = '';
        break;
      default:
    }
  }

  function collectSecurePropertiesForAddOrEditEvent() {
    let secureData = {};
    secureData = setValueIfNotEmpty(secureData, 'shopify_api_pass', 'shopifyApiPassword');
    secureData = setValueIfNotEmpty(secureData, 'shopify_api_key', 'shopifyApiKey');
    secureData = setValueIfNotEmpty(secureData, 'stripe_secret_key', 'stripeSecretKey');
    secureData = setValueIfNotEmpty(secureData, 'occo_api_token', 'occoApiToken');
    secureData = setValueIfNotEmpty(secureData, 'monobank_token', 'monobankToken');
    secureData = setValueIfNotEmpty(secureData, 'rtr_api_token', 'rtrApiToken');
    secureData = setValueIfNotEmpty(secureData, 'square_api_token', 'squareApiToken');
    secureData = setValueIfNotEmpty(secureData, 'sound_payments_username', 'soundPaymentsUsername');
    secureData = setValueIfNotEmpty(secureData, 'sound_payments_password', 'soundPaymentsPassword');
    return secureData;
  }

  this.getEventSecureParams = function (eventName) {
    if (!is_Admin() && !is_Super()) {
      return;
    }
    occoApi.eventSecurePropertiesRetrieve(eventName, (err, result) => {
      if (err) {
        alertMessagePopup(err.message_key);
        return;
      }
      if (result) {
        setEventSecureParams(result);
      }
    });
  };
  function setEventSecureParams(result) {
    Object.entries(result).forEach(([key, value]) => {
      const secureInputElement = elId(key);
      if (secureInputElement) {
        secureInputElement.value = value;
      }
    });
    // this section need to be deleted when for all events opts.shopKey and opts.shopPass will be transfered to event Secure properties.
    tempMigrateOptsShopifyData();
  }
  // Do not use this function , this only for data migration
  function tempMigrateOptsShopifyData() {
    const { shopKey, shopPass } = self.getSelectedEventParam('opts');
    if (shopKey) {
      elId('shopifyApiKey').value = shopKey;
    }
    if (shopPass) {
      elId('shopifyApiPassword').value = shopPass;
    }
  }
  this.getPPTList = function (orgId, selectedEventPptId) {
    occoApi.pptListRetrieve(orgId, null, (err, result) => {
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('pptListRetrieve');
        return;
      }
      drawPPTSelect(result, selectedEventPptId);
    });
  };

  function drawStockImageList(arg) {
    $('#stockImageList').prop('innerHTML', '');
    if (!arg) {
      return;
    }

    let rows = [];

    if (Array.isArray(arg)) {
      rows = arg;
    } else {
      rows.push(arg);
    }

    rows.forEach((row) => {
      self.addStockRow({
        imgUrl: row.full_path,
        imgTmbUrl: row.thumb_full_path,
        imgSize: row.file_size,
        imgTmbSize: row.thumb_size,
        dateStart: row.date_start,
        dateEnd: row.date_end,
        policy: row.policy,
        uid: row.uid,
        renderStyle: row.renderStyle || 'thumb',
        placement: row.placement || '',
        position: row.position || '',
        url: row.url || '',
        availableForPurchase: row.availableForPurchase ?? false,
        applyWatermark: row.applyWatermark === undefined ? row.availableForPurchase ?? false : row.applyWatermark,
        canBeDownloaded: row.canBeDownloaded ?? false,
        canBeMaximized: row.canBeMaximized ?? false,
        showFavorites: row.showFavorites ?? false,
        displayTargets: row.displayTargets || ['webapp', 'kiosk'],
      });
    });
  }

  function getStockImageList(eventId) {
    if (!eventId) return;
    occoApi.stockImageListRetrieve(eventId, (err, result) => {
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('stockImageListRetrieve');
        return;
      }
      drawStockImageList(result);
    });
  }

  function getRobotList(organisationId, robotIdArray) {
    return new Promise((resolve, reject) => {
      setLoadingStateRobotList();
      occoApi.robotListRetrieve(organisationId, (err, result) => {
        if (err) {
          reject(err);
          alertMessagePopup(err.message_key);
          refreshPage('robotListRetrieve');
          return;
        }
        drawRobotList(result.robots, robotIdArray);
        resolve();
      });
    });
  }

  function setLoadingStateRobotList() {
    setLoaderToCont('RobotListCont');
  }

  function getProcessingList(processingIdArray) {
    return new Promise((resolve, reject) => {
      setLoadingStateCloudProcessingList();
      occoApi.processingListRetrieve((err, result) => {
        if (err) {
          reject(err);
          alertMessagePopup(err.message_key);
          refreshPage();
          return;
        }
        drawProcessingList(result, processingIdArray);
        resolve();
      });
    });
  }

  function getOrgList() {
    organisationData.onUpdated(() => {
      drawOrgList(organisationData.data());
    });
    organisationData.onError((error) => {
      alertMessagePopup(error.message_key);
      refreshPage('organisationListRetrieve');
    });
    organisationData.refresh();
  }

  /**
   * Activate functionality in the Edit event of choosing an organization
   */
  this.occoOrgSelectChange = function () {
    const orgId = document.getElementById('occoOrgSelect').value;
    self.getPPTList(orgId, null);
    getRobotList(orgId, null);
  };

  this.getWatermarkTemplateList = function (type, callback) {
    if (!is_Admin() && !is_Super()) {
      return;
    }
    if (type === 1) {
      showLoading();
    }
    setLoaderToCont('watermarkTemplatesList');
    const isWatermarkTemplate = true;
    occoApi.pptListRetrieve(null, isWatermarkTemplate, (err, result) => {
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('pptListRetrieve');
        return;
      }
      const pptId = +self.getSelectedEventParam('ppt_id_array');
      drawPPTSelect(result, pptId);
      switch (type) {
        case 1:
          callback(result);
          hideLoading();
          break;
        case 2:
          callback(result);
          break;
        default:
      }
    });
  };
  this.drawWatermarkTemplatesList = function (result) {
    const watermarkPtId = self.getSelectedEventParam('watermarkPtId');
    const watermarkTemplatesListCont = elId('watermarkTemplatesList');
    const editPhotoWatermarkFromEditButton = elId('editPhotoWatermarkFromEdit');
    const list = $.merge(result.private_ppt_list, result.public_ppt_list);
    if (list.length !== 0) {
      watermarkTemplatesListCont.style.display = 'block';
      editPhotoWatermarkFromEditButton.style.display = 'inline';
      let str = '<select   id="occoWatermarkTemplatesSelect" class="form-control form-control-sm">';
      for (let i = 0; i < list.length; i++) {
        let pub = '';
        if (list[i].is_public !== 0) {
          pub = '(public)';
        }
        str += `<option value=${list[i].id}>${list[i].name} ${pub}</option>`;
      }
      str += '</select>';
      watermarkTemplatesListCont.innerHTML = str;
      if (watermarkPtId && watermarkPtId != 'null') {
        $('#occoWatermarkTemplatesSelect').val(watermarkPtId);
      } else {
        $('#occoWatermarkTemplatesSelect').prop('selectedIndex', 0);
      }
    } else {
      watermarkTemplatesListCont.style.display = 'none';
      editPhotoWatermarkFromEditButton.style.display = 'none';
    }
  };

  this.getEventCodeByHash = function () {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const enameIndex = hash.indexOf('ename=');
      const code = hash.substring(enameIndex + 6, enameIndex + 10);
      if (code && code.length === 4) {
        return code;
      }
    }
    return null;
  };

  function getSelectedEventIdFromSelect() {
    return elId('catSelId').value;
  }

  function getSelectedEventId() {
    return selectedEventId.get();
  }

  function isNeedToSaveSelectedEventId(events) {
    return getSelectedEventId() === null || !isEventExist(getSelectedEventId());

    function isEventExist(eventId) {
      return events.some((event) => event.id === eventId);
    }
  }

  function setEvent(eventId, eventParams) {
    self.EVENT_PARAMS[eventId] = eventParams;
  }

  this.finishSetData = function () {
    self.listeners.forEach((cb) => cb());
  };

  this.onFinishSetData = function (cb) {
    self.listeners.push(cb);
  };

  this.getSelectedEventParam = function (paramName) {
    const eventId = getSelectedEventId();
    if (eventId && self.EVENT_PARAMS?.[eventId]?.[paramName]) {
      return self.EVENT_PARAMS[eventId][paramName];
    }
    if (paramName === 'opts') {
      return {};
    }
    return null;
  };

  this.getEventParamByEventName = function (eventName, paramName) {
    if (eventName && paramName && typeof self.EVENT_PARAMS === 'object') {
      for (const key in self.EVENT_PARAMS) {
        const e = self.EVENT_PARAMS[key];
        if (e?.eventName === eventName && paramName in e) {
          return e[paramName];
        }
      }
    }
    return null;
  };

  this.optionsStoriesPrintPool = function () {
    const defaultValue = [''];
    const printPoolName = elId('printPoolName')?.value;
    if (!printPoolName) return defaultValue;
    return defaultValue.concat(printPoolName.split(','));
  };

  async function uploadSettingInShareBucket(eventSettings) {
    const data = getDataForShareBucket();
    const params = {
      folderPath: `data/`,
      file: createJSONFileForShareBucket(self.getSelectedEventParam('eventName'), data),
    };
    const filePath = `/${params.folderPath}${params.file.name}`;
    return shareBucketApi.uploadFile(params).then(() => shareBucketApi.invalidateCache([filePath]));

    function getDataForShareBucket() {
      return {
        id: self.getSelectedEventParam('eventId'),
        name: self.getSelectedEventParam('eventName'),
        opts: {
          webappBannerBottomLink: eventSettings.opts.webappBannerBottomLink,
          webappBannerBottomSrc: eventSettings.opts.webappBannerBottomSrc,
          webappBannerTopLink: eventSettings.opts.webappBannerTopLink,
          webappBannerTopSrc: eventSettings.opts.webappBannerTopSrc,
        },
      };
    }

    function createJSONFileForShareBucket(eventCode, data) {
      const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
      return new File([blob], `event-${eventCode}.json`, { type: 'application/json' });
    }
  }

  this.getEventPipelineIds = function () {
    let processingIdArray = [];
    const processingIds = self.getSelectedEventParam('processingIds');
    if (processingIds !== '' && processingIds !== 'null' && processingIds != null) {
      processingIdArray = processingIds.split(',');
    }
    return processingIdArray;
  };
}

const occoEvent = new OccoEventClass();
export default occoEvent;
